import React, { useState, useEffect } from 'react';
import { Layout, Menu, Tooltip, Popover, Avatar, Input, Button, Tag, Empty, Result } from 'antd';
import { BrowserRouter as Router1, HashRouter as Router, Route, Link, Redirect, useHistory } from "react-router-dom";
import SubMenu from 'antd/lib/menu/SubMenu';
import './app.css';
import logo from './aquax.jpg';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { EmployeeRolesEnum, UiConfig } from '@gtpl/shared-models/common-models';
import { UserOutlined, EyeOutlined, PlusSquareOutlined, LaptopOutlined, NotificationOutlined, DeliveredProcedureOutlined, DatabaseOutlined, CarOutlined, TeamOutlined, PieChartOutlined, MoneyCollectOutlined, DashboardOutlined, GoldOutlined, SelectOutlined, CarryOutOutlined, PicCenterOutlined, FileProtectOutlined, SnippetsOutlined, TableOutlined, EditOutlined, HomeOutlined, HomeFilled, FrownTwoTone,InsertRowLeftOutlined } from '@ant-design/icons';
import { StarOutlined, StarFilled, StarTwoTone, MenuFoldOutlined, ContainerOutlined, MenuUnfoldOutlined, ExportOutlined, GroupOutlined, FundProjectionScreenOutlined, FilePptOutlined, DropboxOutlined, FundViewOutlined, ReadOutlined, FileDoneOutlined, ScheduleOutlined, ImportOutlined, BookOutlined, DownloadOutlined, RiseOutlined, ExperimentTwoTone,MonitorOutlined,FileSyncOutlined,ExceptionOutlined,InteractionOutlined ,InteractionFilled} from '@ant-design/icons';
import { GrnForm } from '@gtpl/pages/procurement/packing-materials-components/grn-form';
import { GrnGrid } from '@gtpl/pages/procurement/packing-materials-components/grn-grid';
import { CertificationsForm } from '@gtpl/pages/master/master-components/certifications-form';
import { CertificationsGrid } from '@gtpl/pages/master/master-components/certifications-grid';
import { SaleOrderProcessTypesForm } from '@gtpl/pages/master/master-components/sale-order-status-types-form';
import { SaleOrderProcessTypesGrid } from '@gtpl/pages/master/master-components/sale-order-status-types-grid';
import { PaymentModesGrid } from '@gtpl/pages/master/master-components/payment-modes-grid';
import { PaymentModesForm } from '@gtpl/pages/master/master-components/payment-modes-form';
import { SaleOrderTypesForm } from '@gtpl/pages/master/master-components/sale-order-types-form';
import { SaleOrderTypesGrid } from '@gtpl/pages/master/master-components/sale-order-types-grid';
import { UomsForm } from '@gtpl/pages/master/master-components/uoms-form';
import { UomsGrid } from '@gtpl/pages/master/master-components/uoms-grid';
import { PackingMehodsForm } from '@gtpl/pages/master/master-components/packing-methods-form';
import { PackingMethodsGrid } from '@gtpl/pages/master/master-components/packing-methods-grid';
import { DestinationForm } from '@gtpl/pages/master/master-components/destination-form';
import { DestinationGrid } from '@gtpl/pages/master/master-components/destination-grid';
import { EndCustomersForm } from '@gtpl/pages/master/master-components/end-customer-form';
import { EndCustomerGrid } from '@gtpl/pages/master/master-components/end-customer-grid'
import { ItemTypeForm } from '@gtpl/pages/master/master-components/item-type-form';
import { ItemTypeGrid } from '@gtpl/pages/master/master-components/item-type-grid';
import { ItrmTypePages } from '@gtpl/pages/master/master-pages/itrm-type-pages';
import { TaxesGrid } from '@gtpl/pages/master/master-components/taxes-grid';
import { TaxesForm } from '@gtpl/pages/master/master-components/taxes-form';
import { CurrenciesForm } from '@gtpl/pages/master/master-components/currencies-form';
import { CurrenciesGrid } from '@gtpl/pages/master/master-components/currencies-grid';
import { CountriesForm } from '@gtpl/pages/master/master-components/countries-form';
import { CountriesGrid } from '@gtpl/pages/master/master-components/countries-grid';
import { ProductsForm } from '@gtpl/pages/master/master-components/products-form';
import { ProductsGrid } from '@gtpl/pages/master/master-components/products-grid';
import { DepartmentsGrid } from '@gtpl/pages/master/master-components/departments-grid';
import { DepartmentsForm } from '@gtpl/pages/master/master-components/departments-form';
import { HrmsEmployeeDetailsForm } from '@gtpl/pages/master/master-components/hrms-employee-details-form';
import { HrmsEmployeeDetailsGrid } from '@gtpl/pages/master/master-components/hrms-employee-details-grid';
import { TypeOfValueAddition1Form } from '@gtpl/pages/master/master-components/type-of-value-addition1-form';
import { TypeOfValueAddition1Grid } from '@gtpl/pages/master/master-components/type-of-value-addition1-grid';
import { GradeGrid } from '@gtpl/pages/master/master-components/grades-grid';
import { GradeForm } from '@gtpl/pages/master/master-components/grades-form';
import { TypeOfValueAddition2Grid } from '@gtpl/pages/master/master-components/type-of-value-addition2-grid';
import { TypeOfValueAddition2Form } from '@gtpl/pages/master/master-components/type-of-value-addition2-form';
import { TypeOfValueAddition3Grid } from '@gtpl/pages/master/master-components/type-of-value-addition3-grid';
import { TypeOfValueAddition3Form } from '@gtpl/pages/master/master-components/type-of-value-addition3-form';
import { TypeOfValueAddition4Form } from '@gtpl/pages/master/master-components/type-of-value-addition4-form';
import { TypeOfValueAddition4Grid } from '@gtpl/pages/master/master-components/type-of-value-addition4-grid';
import { SaleOrderDetailViewPages } from '@gtpl/pages/sale-management/sale-pages/sale-order-detail-view-pages';
import { SkuDetailView, SkuForm } from '@gtpl/pages/master/master-components/sku-form';
import { SkuGrid } from '@gtpl/pages/master/master-components/sku-grid';
import { HsnCodesForm } from '@gtpl/pages/master/master-components/hsn-codes-form';
import { HsnCodesGrid } from '@gtpl/pages/master/master-components/hsn-codes-grid';

import { SoDesignForm } from '@gtpl/pages/master/master-components/so-design-form';
import { PaymentTermsForm } from '@gtpl/pages/master/master-components/payment-terms-form';
import { PaymentTermsGrid } from '@gtpl/pages/master/master-components/payment-terms-grid';
import { CustomersGrid } from '@gtpl/pages/master/master-components/customers-grid';
import { CustomersForm } from '@gtpl/pages/master/master-components/customers-form';
import { SoDesignGrid } from '@gtpl/pages/master/master-components/so-design-grid';
import { TypeOfFoodGrid } from '@gtpl/pages/master/master-components/type-of-food-grid';
import { TypeOfFoodForm } from '@gtpl/pages/master/master-components/type-of-food-form';
import { SaleOrdersGrid } from '@gtpl/pages/master/master-components/sale-orders-grid';
import { SaleOrderTrackingReportPages } from '@gtpl/pages/sale-management/sale-pages/sale-order-tracking-report-pages';
import { StoreConsumptionReport, IndentReport, StoreReturnReport, PackingBomReport } from '@gtpl/pages/reports/reports-components/store-consumption-report';
import { DeliveryTermsGrid } from '@gtpl/pages/master/master-components/delivery-terms-grid';
import { DeliveryTermsForm } from '@gtpl/pages/master/master-components/delivery-terms-form';
import { ShippingTermsGrid } from '@gtpl/pages/master/master-components/shipping-terms-grid';
import { ShippingTermsForm } from '@gtpl/pages/master/master-components/shipping-terms-form';

import { ItemCategoriesForm } from '@gtpl/pages/master/master-components/item-categories-form';
import { ItemCategoriesGrid } from '@gtpl/pages/master/master-components/item-categories-grid';

import { ItemDamageReasonsForm } from '@gtpl/pages/master/master-components/item-damage-reasons-form';
import { ItemDamageReasonsGrid } from '@gtpl/pages/master/master-components/item-damage-reasons-grid';


import { VendorsForm } from '@gtpl/pages/master/master-components/vendors-form';
import { VendorsGrid } from '@gtpl/pages/master/master-components/vendors-grid';


import { ReasonsForm } from '@gtpl/pages/master/master-components/reasons-form';
import { ReasonsGrid } from '@gtpl/pages/master/master-components/reasons-grid';


import { UnitCodeForm } from '@gtpl/pages/master/master-components/unit-code-form';
import { UnitCodeGrid } from '@gtpl/pages/master/master-components/unit-code-grid'

import { ItemsForm } from '@gtpl/pages/master/master-components/items-form';
import { ItemsGrid } from '@gtpl/pages/master/master-components/items-grid';

import { PurchaseOrderForm } from '@gtpl/pages/procurement-masters/procurement-master-components/purchase-order-form';
import { PurchaseOrderGrid } from '@gtpl/pages/procurement-masters/procurement-master-components/purchase-order-grid';

import { StoreConsumptionForm } from '@gtpl/pages/procurement/packing-materials-components/store-consumption-form';
import { StoreConsumptionGrid } from '@gtpl/pages/procurement/packing-materials-components/store-consumption-grid';
import { StoreConsumptionDetailView } from '@gtpl/pages/procurement/packing-materials-components/store-consumption-detail-view';

import { GrnRejectionReasonsForm } from '@gtpl/pages/master/master-components/grn-rejection-reasons-form';
import { GrnRejectionReasonsGrid } from '@gtpl/pages/master/master-components/grn-rejection-reasons-grid';

import { SizesForm } from '@gtpl/pages/master/master-components/sizes-form';
import { SizesGrid } from '@gtpl/pages/master/master-components/sizes-grid';

import { HatcheriesForm } from '@gtpl/pages/master/master-components/hatcheries-form';
import { HlPercentagesForm } from '@gtpl/pages/master/master-components/hl-percentages-form';
import { HatcheriesGrid } from '@gtpl/pages/master/master-components/hatcheries-grid';
import { HlPercentagesGrid } from '@gtpl/pages/master/master-components/hl-percentages-grid';
import { SuppliersGrid } from '@gtpl/pages/master/master-components/suppliers-grid';
import { SuppliersForm } from '@gtpl/pages/master/master-components/suppliers-form';

import { RolesForm } from '@gtpl/pages/master/master-components/roles-form';
import { RolesGrid } from '@gtpl/pages/master/master-components/roles-grid'
import { TypeOfValueAddition5Form } from '@gtpl/pages/master/master-components/type-of-value-addition5-form';
import { TypeOfValueAddition5Grid } from '@gtpl/pages/master/master-components/type-of-value-addition5-grid';

import { GrnDetailviewGrid } from '@gtpl/pages/procurement/packing-materials-components/grn-detailview-grid';

import { BomParameterGrid } from '@gtpl/pages/sale-management/sale-components/bom-parameter-grid';
import { BomParameter } from '@gtpl/pages/sale-management/sale-pages/bom-parameter';
import { BomParameterDetailView } from '@gtpl/pages/sale-management/sale-components/bom-parameter-grid';

import { StoreReturnPages } from '@gtpl/pages/procurement/packing-materials-pages/store-return-pages';
import { StoreReturnGrid, StoreReturnDetailView } from '@gtpl/pages/procurement/packing-materials-components/store-return-grid';
import { StoreReturnForm } from '@gtpl/pages/procurement/packing-materials-components/store-return-form';
import { PoDetailviewGrid } from '@gtpl/pages/procurement-masters/procurement-master-components/po-detailview-grid';
import { PoDetailViewPages, PoPrint } from '@gtpl/pages/procurement-masters/procurement-master-pages/po-detail-view-pages';
import { VendorPriceListGrid } from '@gtpl/pages/master/master-components/vehicle-price-list-grid';

import { VendorPriceListForm } from '@gtpl/pages/master/master-components/vehicle-price-list-form';
import { TransferPrint } from "@gtpl/pages/procurement/packing-materials-components/transfer-print";
import { GrnReturnForm } from '@gtpl/pages/procurement/packing-materials-components/grn-return-form';
import { GrnReturnGrid } from "@gtpl/pages/procurement/packing-materials-components/grn-return-grid";
import { GrnReturnDetailView } from "@gtpl/pages/procurement/packing-materials-components/grn-return-grid";
import { PackingStockTransfer, PackingStockEntry,PackingProductConversion, CycleChecker } from "@gtpl/pages/procurement/packing-materials-components/stock-transfer";
import { ReportingForm } from '@gtpl/pages/warehouse-management/warehouse-components/reporting-form';
import { StockInForm } from '@gtpl/pages/warehouse-management/warehouse-components/stock-in-form';
import { ShipmentStatusReport, StockGrid, StockOutTransaction } from '@gtpl/pages/warehouse-management/warehouse-components/stock-grid';
import { StockReportWarehouse, StockInTransactionsReport, DummyPackingReport } from '@gtpl/pages/warehouse-management/warehouse-components/stock-grid';
import { StockInReverse } from '@gtpl/pages/warehouse-management/warehouse-components/stock-out';
import { EndCustomerSoReport, SaleOrderReportGrid, SaleDetailsReport } from '@gtpl/pages/reports/reports-components/sale-order-report-grid';
import { PurchaseOrderReport, SoPackingStatus } from '@gtpl/pages/reports/reports-components/purchase-order-report';
import { StockReport } from '@gtpl/pages/reports/reports-components/stock-report';
import { GrnReportGrid } from '@gtpl/pages/reports/reports-components/grn-report';
import { GrnAbstractReportGrid } from '@gtpl/pages/reports/reports-components/grn-report';
import { Dashboard, FactoryHeadDashboardGrid } from '@gtpl/pages/dashboard/dashboard-components/factory-head-dashboard-grid';
import { LevelGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/level-grid';
import { LevelForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/level-form';
import { PalletGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/pallet-grid';
import { PalletForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/pallet-form';
import { ColumnsGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/columns-grid';
import { ColumnsForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/columns-form';
import { RackGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-grid'
import { RackForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-form'
import { RacksMasterGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/racks-master-grid';
import { RacksMasterForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/racks-master-form'
import { ZoneGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/zone-grid'
import { ZoneForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/zone-form';
import { RackEndcustomerMappingForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-endcustomer-mapping-form';
import { RackEndcustomerMappingGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-endcustomer-mapping-grid';
import { ContainerRegisterGrid } from '@gtpl/pages/logistics/logistics-components/container-register-grid';
import { ContainerReport } from '@gtpl/pages/reports/reports-components/container-report';
import { Invoice } from '@gtpl/pages/logistics/logistics-components/invoice';
import { InvoiceGrid } from '@gtpl/pages/logistics/logistics-components/invoice-grid';
import { LogisticsInvoiceDetailView } from '@gtpl/pages/logistics/logistics-components/invoice-detail-view';
import { RmProcurementReportGrid } from '@gtpl/pages/reports/reports-components/rm-procurement-report-grid';

import { BookContainer, ContainerRegister, DispatchToPlant, AssignSo, FillSealInfo } from '@gtpl/pages/logistics/logistics-components/container-register';

import { LocationsGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/locations-grid';
import { LocationsForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/locations-form';

import { BlStatusGrid } from '@gtpl/pages/logistics/logistics-components/bl-status-grid';

import { MasterBrandsForm } from '@gtpl/pages/master/master-components/master-brands-form';
import { MasterBrandsGrid } from '@gtpl/pages/master/master-components/master-brands-grid';
import { CommonInvoice, CusInvoice, CommonPackingList, ShippingInstructions, PackingList, CommercialPackingList, CommercialInvoice, InsuranceUpload, FreigstInvoice, TaxInvoice, PlantInvoice, PlantPackingList, DocumentRegister, IsfWorksheet, DocumentUploadForm } from '@gtpl/pages/logistics/logistics-components/documents';

import { StockView } from '@gtpl/pages/procurement/packing-materials-components/stock-view';

import { WarehouseDashboard } from '@gtpl/pages/warehouse-management/warehouse-components/warehouse-dashboard';
import { DocumentsApprovalPages } from '@gtpl/pages/logistics/logistics-components/documents-approval-pages';
import { DocumentsApprovalForm } from '@gtpl/pages/logistics/logistics-components/documents-approval-form';

import { UserGrid } from '@gtpl/pages/user-management/user-components/user-grid';
import { UserForm } from '@gtpl/pages/user-management/user-components/user-form';
import { UserPages } from '@gtpl/pages/user-management/user-management-pages/user-pages';

import { SoInspectionGrid } from '@gtpl/pages/inspection/inspection-components/so-inspection-grid';


import { RawMaterialGrnForm } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/raw-material-grn-form';
import { RawMaterialGrnGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/raw-material-grn-grid';
import { RawMaterialGrnDetailView } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/raw-material-grn-detail-view'
// indent form
import { IndentForm } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/indent-form';
import { IndentGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/indent-grid';
import { IndentDetailView, IndentDetailViewPages } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/indent-detail-view';
import { VehicleAssignmentGrid } from '@gtpl/pages/transportation/transportation-components/vehicle-assignment-grid';
import { VehicleAssignmentForm } from '@gtpl/pages/transportation/transportation-components/vehicle-assignment-form';
import { BomTrackerGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/bom-tracker-grid'
import { ProcurementDashboard } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/procurement-dashboard';
import { VehicleMasterForm } from '@gtpl/pages/master/master-components/vehicle-master-form';
import { VehicleMasterGrid } from '@gtpl/pages/master/master-components/vehicle-master-grid';
import { RmProcurementDashboard } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-procurement-dashboard';
import { RmDashboard } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-dashboard';
import { OperationsForm } from '@gtpl/pages/production-management/production-management-components/operations-form';
import { OperationsGrid } from '@gtpl/pages/production-management/production-management-components/operations-grid';
import { WorkstationCategoryForm } from '@gtpl/pages/production-management/production-management-components/workstation-category-form';
import { WorkstationCategoryGrid } from '@gtpl/pages/production-management/production-management-components/workstation-category-grid';
import { WorkstationsForm } from '@gtpl/pages/production-management/production-management-components/workstations-form';
import { QaQcGrid } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-grid';
import { QaQcOperations } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-operations';
import { InspectionForm } from '@gtpl/pages/qa-qc/qa-qc-components/product-inspection-form';
import { InspectionPrint } from '@gtpl/pages/qa-qc/qa-qc-components/product-inspection-print';
import { PdQaqcForm } from '@gtpl/pages/production-management/production-management-components/peeling-preparation-form';
import { PdQaqcPrint } from '@gtpl/pages/production-management/production-management-components/peeling-preparation-print';

import { MetalDetection } from '@gtpl/pages/qa-qc/qa-qc-components/metal-detection';
import { MetalDetectionForm } from '@gtpl/pages/qa-qc/qa-qc-components/metal-detection-form';

import { VariantOperationsForm } from '@gtpl/pages/production-management/production-management-components/variant-operations-form';
import { WorkstationsGrid } from '@gtpl/pages/production-management/production-management-components/workstations-grid';
import { BeHeading } from '@gtpl/pages/production-management/production-management-components/assign-rm-inventory';
import { AssignGradeToValAddition } from '@gtpl/pages/production-management/production-management-components/assign-grade-to-val-addition';
import { AssignSoakingMaterial } from '@gtpl/pages/production-management/production-management-components/assign-soaking-material';
import { SoakingReporting } from '@gtpl/pages/production-management/production-management-components/soaking-reporting';
import { SoakingDashboard } from '@gtpl/pages/production-management/production-management-components/soaking-dashboard';
import { SoakingMaterialGrid } from '@gtpl/pages/production-management/production-management-components/soaking-material-grid';
import { SoakingMaterialDetailView } from '@gtpl/pages/production-management/production-management-components/soaking-material-detail-view';
import { ValAdditionInventoryGrid } from '@gtpl/pages/production-management/production-management-components/val-addition-inventory-grid';
import { ValAdditionSoakingGrid } from '@gtpl/pages/production-management/production-management-components/val-addition-soaking-grid';
import { ValAdditionGradingDashboard } from '@gtpl/pages/production-management/production-management-components/val-addition-grading-dashboard';
import { AssignSoGrading } from '@gtpl/pages/production-management/production-management-components/assign-so-grading';
import { GradingInventoryGrid } from '@gtpl/pages/production-management/production-management-components/grading-inventory-grid';
import { GradingDashboard } from '@gtpl/pages/production-management/production-management-components/grading-dashboard';
import { GradeReporting } from '@gtpl/pages/production-management/production-management-components/grade-reporting';
import { AssignBeheadingToGrading } from '@gtpl/pages/production-management/production-management-components/assign-beheading-to-grading';
import { YieldReport } from '@gtpl/pages/production-management/production-management-components/yield-report';
import { BeheadingDashboard } from '@gtpl/pages/production-management/production-management-components/beheading-dashboard';
import { SubPlantValAdditionsReport } from '@gtpl/pages/production-management/production-management-components/sub-plant-val-additions-report';
import { ProductionInventoryGrid } from '@gtpl/pages/production-management/production-management-components/production-inventory-grid';

import { BeheadingInventoryGrid } from '@gtpl/pages/production-management/production-management-components/beheading-inventory-grid';
import { BeheadingSubPlantHistory } from '@gtpl/pages/production-management/production-management-components/beheading-sub-plant-history'
import { SoakingMaterialInventory } from '@gtpl/pages/production-management/production-management-components/soaking-material-inventory';
import { SubPlantOperationsGrid } from '@gtpl/pages/production-management/production-management-components/sub-plant-operations-grid';

import { AssignSoakingToFreezeGrid } from '@gtpl/pages/production-management/production-management-components/assign-soaking-to-freeze-grid';
import { ReportSubPlantOperations } from '@gtpl/pages/production-management/production-management-components/report-sub-plant-operations';
import { ReceiveSubPlantsStockNew } from '@gtpl/pages/production-management/production-management-components/receive-sub-plants-stock';
import { AssignForFreezingForm } from '@gtpl/pages/production-management/production-management-components/assign-for-freezing-form';
import { BeheadingInprogressGrid } from '@gtpl/pages/production-management/production-management-components/beheading-inprogress-grid';
import { OperationsRegister } from '@gtpl/pages/reports/reports-components/operations-register';
import { CookingGrid } from '@gtpl/pages/production-management/production-management-components/cooking-grid';

import { RejectionsGrid } from '@gtpl/pages/production-management/production-management-components/rejections-grid';

import { ProductionInventoryTransfer } from '@gtpl/pages/production-management/production-management-components/production-inventory-transfer';

// import { RejectionsGrid } from '@gtpl/pages/production-management/production-management-components/rejections-grid';
import { LotTrackingReport } from '@gtpl/pages/reports/reports-components/lot-tracking-report';
import { FgInspectionForm } from '@gtpl/pages/qa-qc/qa-qc-components/fg-inspection-form';
import { FgInspectionPrint } from '@gtpl/pages/qa-qc/qa-qc-components/fg-inspection-print';
import { QaQcSampleTest } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-sample-test'
import { QaQcSampleTestGrid } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-sample-test-grid'
import { QaQcSampleDetailView } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-sample-detail-view'
import { PackingDashboard } from '@gtpl/pages/procurement/packing-materials-components/packing-dashboard';
import { PackingBOM } from '@gtpl/pages/procurement/packing-materials-components/packing-dashboard';
import { QualificationsForm } from '@gtpl/pages/hrms/hrms-components/qualifications';
import { QualificationsGrid } from '@gtpl/pages/hrms/hrms-components/qualifications-grid';
import { RecruitmentForm } from '@gtpl/pages/hrms/hrms-components/recruitment-mode-form';
import { RecruitmentGrid } from '@gtpl/pages/hrms/hrms-components/recruitment-mode';
import { DesignationActionForm } from '@gtpl/pages/hrms/hrms-components/designation-action-form';
import { DesignationActionGrid } from '@gtpl/pages/hrms/hrms-components/designation-action-grid'
import { PlantOperationCapacityForm } from '@gtpl/pages/master/master-components/plant-operation-capacity-form';
import { PlantOperationCapacityGrid } from '@gtpl/pages/master/master-components/plant-operation-capacity-grid';
import { ExpensesCategory } from '@gtpl/pages/hrms/hrms-components/expenses-category';
import { ExpensesCategoryGrid } from '@gtpl/pages/hrms/hrms-components/expenses-category-grid';
import { ExpensesSubCategory } from '@gtpl/pages/hrms/hrms-components/expenses-sub-category';
import { ExpensesSubCategoryGrid } from '@gtpl/pages/hrms/hrms-components/expenses-sub-category-grid';
import { Skills } from '@gtpl/pages/hrms/hrms-components/skills';
import { SkillsGrid } from '@gtpl/pages/hrms/hrms-components/skills-grid';
import { Designation } from '@gtpl/pages/hrms/hrms-components/designation';
import { DesignationGrid } from '@gtpl/pages/hrms/hrms-components/designation-grid';
import { ExpensesForm } from '@gtpl/pages/hrms/hrms-components/expenses';
import { ExpensesGrid } from '@gtpl/pages/hrms/hrms-components/expenses-grid';
import { LanguagesForm } from '@gtpl/pages/hrms/hrms-components/languages';
import { LanguagesGrid } from '@gtpl/pages/hrms/hrms-components/languages-grid';
import { TransferActionForm } from '@gtpl/pages/hrms/hrms-components/transfer-action-form';
import { TransferActionGrid } from '@gtpl/pages/hrms/hrms-components/transfer-action-grid';
import { HolidaysCalender } from '@gtpl/pages/hrms/hrms-components/holidays-calender';
import { HolidaysCalenderGrid } from '@gtpl/pages/hrms/hrms-components/holidays-calender-grid';
import { EmploymentStatusForm } from '@gtpl/pages/hrms/hrms-components/employment-status-form';
import { EmploymentStatusGrid } from '@gtpl/pages/hrms/hrms-components/employment-status-grid';
import { ProfilesForm } from '@gtpl/pages/hrms/hrms-components/profiles-form';
import { ProfilesGrid } from '@gtpl/pages/hrms/hrms-components/profiles-grid';
import { NotificationsForm } from '@gtpl/pages/hrms/hrms-components/notifications-form';
import { NotificationsGrid } from '@gtpl/pages/hrms/hrms-components/notifications-grid';

import { ActivitiesForm } from '@gtpl/pages/hrms/hrms-components/activities-form';
import { ActivitiesGrid } from '@gtpl/pages/hrms/hrms-components/activities-grid';

import { InterviewForm } from '@gtpl/pages/hrms/hrms-components/schedule-interview-form';
import { InterviewGrid } from '@gtpl/pages/hrms/hrms-components/interview-grid';

import { CodeListForm } from '@gtpl/pages/planning/planning-components/code-list-form';
import { CodeListGrid, CodeListPrint } from '@gtpl/pages/planning/planning-components/code-list-grid';
import { ResourceOperationEfficiencyGrid } from '@gtpl/pages/planning/planning-components/resource-operation-efficiency-grid'
import { ResourceOperationEfficiencyForm } from '@gtpl/pages/planning/planning-components/resource-operation-efficiency-form'
import { PlantCapacityForm } from '@gtpl/pages/planning/planning-components/plant-capacity-form'
import { DowntimeReasonForm} from '@gtpl/pages/master/master-components/downtime-reason-form';
import{DowntimeReasonGrid} from '@gtpl/pages/master/master-components/downtime-reason-grid';

// import { UserMenu } from './user-menu';
// import { DashboardsMenu } from './dashboards-menu';
// import { SalesMenu } from './sales-menu';
// import { MastersMenu } from './masters-menu';
// import { RmProcMenu } from './rm-proc-menu';
// import { WhMenu } from './wh-menu';
// import { LogisticsMenu } from './logistics-menu';
// import { PackingMenu } from './packing-menu';
// import { InspectionMenu } from './inspection-menu';
// import { ReportsMenu } from './reports-menu';

import { ItemSubCategoriesForm } from '@gtpl/pages/master/master-components/item-sub-categories-form';
import { ItemSubCategoriesGrid } from '@gtpl/pages/master/master-components/item-sub-categories-grid';
import { IdProofs } from '@gtpl/pages/hrms/hrms-components/id-proofs';
import { IdProofsGrid } from '@gtpl/pages/hrms/hrms-components/id-proofs-grid';
import { Relations } from '@gtpl/pages/hrms/hrms-components/relations';
import { RelationsGrid } from '@gtpl/pages/hrms/hrms-components/relations-grid';

import { LoanCategoriesGrid } from '@gtpl/pages/hrms/hrms-components/loan-categories-grid';
import { LoanCategories } from '@gtpl/pages/hrms/hrms-components/loan-categories';
import { OverTimeCategoryGrid } from '@gtpl/pages/hrms/hrms-components/over-time-category-grid';
import { OverTimeCategory } from '@gtpl/pages/hrms/hrms-components/over-time-category';
import { Suggestion } from '@gtpl/pages/hrms/hrms-components/suggestion';
import { SuggestionGrid } from '@gtpl/pages/hrms/hrms-components/suggestion-grid';
// import {SuggestionGrid} from '@gtpl/pages/hrms/hrms-components/suggestion-grid';
// import {Suggestion} from '@gtpl/pages/hrms/hrms-components/suggestion';
import { ComplaintsGrid } from '@gtpl/pages/hrms/hrms-components/complaints-grid';
import { Complaints } from '@gtpl/pages/hrms/hrms-components/complaints';
import { StockOut } from '@gtpl/pages/warehouse-management/warehouse-components/stock-out';

import { FgStockTransferGrid } from '@gtpl/pages/warehouse-management/warehouse-management-components/fg-stock-transfer-grid';
import { FgStockTransfer } from '@gtpl/pages/warehouse-management/warehouse-management-components/fg-stock-transfer';
import { SoInfoView } from '@gtpl/pages/sale-management/sale-pages/so-info-view';
import { SoInfoViewPages } from '@gtpl/pages/sale-management/sale-pages/so-info-view-pages';

import { dispatchlistgrid } from '@gtpl/pages/warehouse-management/warehouse-components/dispatch-list-grid';

import { StockTransferGrid } from '@gtpl/pages/procurement/packing-materials-components/stock-transfer-grid';
import { StockTransferDetailView } from '@gtpl/pages/procurement/packing-materials-components/stock-transfer-detail-view';
import { CaptureGrossWeightForm } from '@gtpl/pages/logistics/logistics-components/capture-gross-weight-form';
import { RmVehicleInspection } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-vehicle-inspection';
import { LogBookGrid } from '@gtpl/pages/logistics/logistics-components/log-book-grid';
import { ExitActionForm } from '@gtpl/pages/hrms/hrms-components/exit-action-form';
import { ExitActionGrid } from '@gtpl/pages/hrms/hrms-components/exit-action-grid';
import { TypesOfLeaves } from '../../../../../libs/pages/hrms/hrms-components/types-of-leaves/src';
import { TypesOfLeavesGrid } from '../../../../../libs/pages/hrms/hrms-components/types-of-leaves-grid/src'
import { EmployeeLeavesGrid } from '@gtpl/pages/hrms/hrms-components/employee-leaves-grid'
import { JobNotificationsForm } from '@gtpl/pages/hrms/hrms-components/job-notifications-form';
import { JobNotificationsGrid } from '@gtpl/pages/hrms/hrms-components/job-notifications-grid';
import { Education } from '@gtpl/pages/hrms/hrms-components/education';
import { EducationGrid } from '@gtpl/pages/hrms/hrms-components/education-grid';
import { Certification } from '@gtpl/pages/hrms/hrms-components/certification';
import { CertificationGrid } from '@gtpl/pages/hrms/hrms-components/certification-grid';
import { ReprocessingRepackingGrid } from '@gtpl/pages/warehouse-management/warehouse-components/reprocessing-repacking-grid';
import { ReserveRackPositions } from '@gtpl/pages/warehouse-management/warehouse-components/reserve-rack-positions';
import { ApplyForLeavesForm } from '@gtpl/pages/hrms/hrms-components/apply-for-leaves-form'
import { ApplyForLeavesGrid } from '@gtpl/pages/hrms/hrms-components/apply-for-leaves-grid';
import { LeaveApprovalGrid } from '@gtpl/pages/hrms/hrms-components/leave-approval-grid'
import { LabellingForm } from '@gtpl/pages/qa-qc/qa-qc-components/labelling-form';
import { LabellingGrid } from '@gtpl/pages/qa-qc/qa-qc-components/labelling-grid';
import { BlanchingCookingForm } from '@gtpl/pages/production-management/production-management-components/blanching-cooking-form';
import { CookingForm } from '@gtpl/pages/production-management/production-management-components/assign-cooking-form';

import { ShippmentDetailsForm, ShippmentDetailsReceivedTabForm } from '@gtpl/pages/logistics/logistics-components/shippment-details-form';
import { InsuranceForm } from '@gtpl/pages/master/master-components/insurance-form'
import { InsuranceGrid } from '@gtpl/pages/master/master-components/insurance-grid'
import ScrollNumber from 'antd/lib/badge/ScrollNumber';
import { FgStockSummaryReport, FgStockReport } from '@gtpl/pages/warehouse-management/warehouse-management-components/fg-stock-summary-report';
import { RmToleranceGrid } from '@gtpl/pages/master/master-components/rm-tolerance-grid';
import { RmToleranceForm } from '@gtpl/pages/master/master-components/rm-tolerance-form';
import { RmIndentQtyLimitGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-indent-qty-limit-grid';
import { RmIndentQtyLimit } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-indent-qty-limit';
import { GradeSuggestionFrom } from '@gtpl/pages/master/master-components/grade-suggestion-from';
import { PalletCapacityGrid } from '@gtpl/pages/master/master-components/pallet-capacity-grid';
import { PalletCapacityForm } from '@gtpl/pages/master/master-components/pallet-capacity-form';

import { TrimsGrid } from '@gtpl/pages/master/master-components/shrimps-grid';
import { TrimsForm } from '@gtpl/pages/master/master-components/shrimps-form';
import { CodeListMainForm } from '@gtpl/pages/planning/planning-components/code-list-main-form';
import { CodeListMainGrid } from '@gtpl/pages/planning/planning-components/code-list-main-grid';

import { NotifyPartyGrid } from '@gtpl/pages/master/master-components/notify-party-grid';
import { NotifyPartyForm } from '@gtpl/pages/master/master-components/notify-party-form';
import { TypesForm } from '@gtpl/pages/master/master-components/types-form';
import { TypesGrid } from '@gtpl/pages/master/master-components/types-grid';
import { faArrowUpShortWide, faCartShopping, faCertificate, faCode, faCommentSlash, faDiceFive, faDiceFour, faDiceOne, faDiceThree, faDiceTwo, faFileCircleQuestion, faIdBadge, faMoneyBillWaveAlt, faNetworkWired, faNewspaper, faRuler, faShrimp, faUsers, faUsersRays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faArrowRightToBracket, faArrowsRotate, faBook, faBoxesStacked, faBoxOpen, faCartFlatbedSuitcase, faColumns, faFile, faFileCircleCheck, faFileInvoice, faFileLines, faPallet, faSnowflake, faTruckFast, faTruckLoading, faTruckPickup, faWarehouse } from '@fortawesome/free-solid-svg-icons';

const { Header, Sider, Content, Footer }: any = Layout;
export const BasicLayout = React.memo((props: any) => {
    const [collapsed, setcollapsed] = useState(true);
    const [selectedMenu, setselectedMenu] = useState('/');
    const [subMenu, setSubmenu] = useState([]);
    const [username, setUserName] = useState<string>(props.username);
    // console.log(props.user.username);
    if (props) {
        const [UserName, setUserName] = useState<string>();
    }




    const user_name_local = JSON.parse(localStorage.getItem('username'));
    console.log('role');
    console.log(localStorage.getItem('role'));
    const Search = Input.Search;
    const uiConfig = new UiConfig();

    useEffect(() => {
        console.log(JSON.parse(localStorage.getItem('role')));
        console.log(props.user);
        let href = window.location.href.split('/');
        setUserName(props.user.user_data.username);
        // localStorage.setItem("createdUser", 'Admin');
        const routeLink = href[3];
        if (routeLink) {
            setselectedMenu(routeLink);
            const rootMenus = ['mdm', 'sms', 'pps', 'pts'];
            if (!rootMenus.includes(routeLink)) {
                if (routeLink === 'plantCalendar' || routeLink === 'editPlantCalendar') {
                    setSubmenu(['subPlantCalendarMenu', 'pms'])
                } else {
                    setSubmenu(['pms'])
                }
            }
        } else {
            setSubmenu(['pms'])
            setselectedMenu('/');
        }
    }, [])

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => setLoading(false), 1000)
    }, [])

    const menu = (e) => {
        if (e.keyPath.length < 2) {
            setSubmenu([])
            setselectedMenu(e.key)
        } else {
            setSubmenu(e.keyPath)
            setselectedMenu(e.key)
        }
    }
    const { SubMenu } = Menu;
    const toggle = () => {
        setcollapsed(!collapsed);
    }

    const onOpenChange = (openKeys: string[]) => {
        setSubmenu(openKeys)
    }

    const logOut = () => {
        localStorage.clear();
        window.location.reload();
        AlertMessages.getSuccessMessage('Logging out');

    }
    const ifNotHaveAccess = () => {
        return <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
        // extra={<Link to='' ><Button type="primary">Back Home</Button></Link>}
        />
    }
    return (<Layout className="layout">
        <Router>

            <Sider breakpoint="lg" collapsedWidth="80" className='noprint'
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                }}
                collapsible
                onCollapse={(collapsed, type) => {
                    setcollapsed(true);
                }} collapsed={collapsed} trigger={null}>
                <div className="logo" >
                    <img src={logo} />
                    {/* <h1 style={{ display: collapsed ? 'none' : 'block' }}>AquaX</h1> */}
                </div>
                <Menu theme="dark" mode="inline"
                    onClick={menu}
                    openKeys={subMenu}
                    defaultOpenKeys={[]} style={{ paddingTop: "20px" }}
                    selectedKeys={[selectedMenu]}
                    onOpenChange={onOpenChange}
                    defaultSelectedKeys={['/']} >
                    {/* <Menu.Item key="dashboards" icon={<PieChartOutlined />}>
                        <a href='#'>   <span>Dashboards</span></a>
                    </Menu.Item> */}

                    {/* <UserMenu/>
                    <DashboardsMenu/>
                    <MastersMenu/>
                    <SalesMenu/>
                    <PackingMenu/>
                    <RmProcMenu/>
                    <WhMenu/>
                    <LogisticsMenu/>
                    <InspectionMenu/>
                    <ReportsMenu/> */}

                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="user-management" icon={<UserOutlined />}
                            title={
                                <span>
                                    <span>Users</span>
                                </span>
                            }
                        >
                            <Menu.Item key="ums-grid" icon={<UserOutlined />}>
                                <Link to="/user-grid"><span>Users</span></Link>
                            </Menu.Item>

                        </SubMenu>
                    }
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                        <SubMenu
                            key="dashboards" icon={<PieChartOutlined />}
                            title={
                                <span>
                                    <span>Dashboards</span>
                                </span>
                            }
                        >
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <Menu.Item key="fh-dashboard-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/fh-dashboard-grid"><span>Factory Head</span></Link>
                                </Menu.Item>
                            }
                            {/* <Menu.Item key="so-track" icon={<PicCenterOutlined />}>
                            <Link to="/so-track"><span>So Tracker</span></Link>
                        </Menu.Item> */}
                            <Menu.Item key="wh-dashboard" icon={<PicCenterOutlined />}>
                                <Link to="/wh-dashboard"><span>Ware House</span></Link>
                            </Menu.Item>
                            <Menu.Item key="dashboard" icon={<PicCenterOutlined />}>
                                <Link to="/dashboard"><span>Dashboard</span></Link>
                            </Menu.Item>
                        </SubMenu>
                    }
                    {(([
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.NAVTECH_WH,
                        EmployeeRolesEnum.ASSISTANT_SALES_MANAGER,
                        EmployeeRolesEnum.SR_SALES_MANAGER,
                        EmployeeRolesEnum.PLANT_SALES_MANAGER,
                        EmployeeRolesEnum.HO_SALES_MANAGER,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.HO_PACKAGING_MANAGER
                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1)
                        &&
                        <SubMenu
                            key="masters" icon={<UserOutlined />}
                            title={
                                <span>
                                    <span>Masters</span>
                                </span>
                            }
                        >
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="global_masters" icon={<UserOutlined />}
                                    title={
                                        <span>
                                            <span>Global</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="certificates-view" icon={<PicCenterOutlined />}>
                                        <Link to="/certificates-view"><span>Certificates</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="Countries-view" icon={<PicCenterOutlined />}>
                                        <Link to="/Countries-view"><span>Countries</span></Link>
                                    </Menu.Item>
                                    
                                    <Menu.Item key="DownTimeReason-view" icon={<PicCenterOutlined />}>
                                        <Link to="/DownTimeReason-view"><span>DownTimeReason</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="destination-view" icon={<PicCenterOutlined />}>
                                        <Link to="/destination-view"><span>Destination</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="Currencies-view" icon={<PicCenterOutlined />}>
                                        <Link to="/Currencies-view"><span>Currencies</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="customers-view" icon={<PicCenterOutlined />}>
                                        <Link to="/customers-view"><span>Customers</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="delivery-terms-view" icon={<PicCenterOutlined />}>
                                        <Link to="/delivery-terms-view"><span>Delivery Terms</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="packingmethods-view" icon={<PicCenterOutlined />}>
                                        <Link to="/Packingmethods-view"><span>Packing Methods</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="Payment-modes-view" icon={<PicCenterOutlined />}>
                                        <Link to="/Payment-modes-view"><span>Payment Modes</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="payment-terms-view" icon={<PicCenterOutlined />}>
                                        <Link to="/payment-terms-view"><span>Payment Terms</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="shipping-terms-view" icon={<PicCenterOutlined />}>
                                        <Link to="/shipping-terms-view"><span>Shipping Terms</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="taxes-view" icon={<PicCenterOutlined />}>
                                        <Link to="/taxes-view"><span>Taxes</span></Link>
                                    </Menu.Item>


                                    <Menu.Item key="UOMs-view" icon={<PicCenterOutlined />}>
                                        <Link to="/UOMs-view"><span>UOMs</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="unitcode-view" icon={<PicCenterOutlined />}>
                                        <Link to="/unitcode-view"><span>Plants</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="/insurance-view" icon={<PicCenterOutlined />}>
                                        <Link to="/insurance-view"><span>Insurance Details</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/notify-party-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/notify-party-grid"><span>Notify Party</span></Link>
                                    </Menu.Item>

                                </SubMenu>
                            }
                            {/* Global Masters Ending */}
                            {/* Sales Masters Starting */}
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SR_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_SALES_MANAGER)) &&
                                <SubMenu
                                    key="sales_masters" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>Sales</span>
                                        </span>
                                    }
                                >

                                    <Menu.Item key="master-brands-grid" icon={<FontAwesomeIcon icon={faCertificate} />}>
                                        <Link to="/master-brands-grid"><span>Brands</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="EndCustomerView" icon={<FontAwesomeIcon icon={faUsers} />} >
                                        <Link to="/EndCustomerview" >
                                            <span>End Customer</span>
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="Grades-view" icon={<FontAwesomeIcon icon={faArrowUpShortWide} />}>
                                        <Link to="/Grades-view"><span>Grade</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="typeofFood-view" icon={<FontAwesomeIcon icon={faShrimp} />}>
                                        <Link to="/typeofFood-view"><span>Food Type</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="products-view" icon={<FontAwesomeIcon icon={faCartShopping} />}>
                                        <Link to="/Products-view"><span>Products</span></Link>
                                    </Menu.Item>
                                    {/* <SubMenu key="products" icon={<PicCenterOutlined />} title="Products">
                          <Menu.Item key="products-form" icon={<PlusSquareOutlined />}>
                          <Link to="/Products-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="products-view" icon={<EyeOutlined/>}>
                          <Link to="/Products-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}

                                    {/* <Menu.Item key="saleordertypes-view" icon={<PicCenterOutlined />}>
                                <Link to="/saleordertypes-view"><span>SO Types</span></Link>
                            </Menu.Item> */}


                                    {/* <SubMenu key="saleordertypes" icon={<PicCenterOutlined />} title="SO Types">
                          <Menu.Item key="saleordertypes-form" icon={<PlusSquareOutlined />}>
                          <Link to="/saleordertypes-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="saleordertypes-view" icon={<EyeOutlined/>}>
                          <Link to="/saleordertypes-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}

                                    {/* <Menu.Item key="orderprocesstypes-view" icon={<PicCenterOutlined />}>
                                <Link to="/saleorderprocesstypes-view"><span>So Process Type</span></Link>
                            </Menu.Item> */}

                                    {/* <SubMenu key="orderprocesstypes" icon={<PicCenterOutlined />} title="SO Process type">
                          <Menu.Item key="orderprocesstypes-form" icon={<PlusSquareOutlined />}>
                          <Link to="/saleorderprocesstypes-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="orderprocesstypes-view" icon={<EyeOutlined/>}>
                          <Link to="/saleorderprocesstypes-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}
                                    {/* <SubMenu key="sales" icon={<PicCenterOutlined />} title="Sales">
                          <Menu.Item key="sales-form" icon={<PlusSquareOutlined />}>
                          <Link to="/Sales-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="sales-view" icon={<EyeOutlined/>}>
                          <Link to="/Sales-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}



                                    <Menu.Item key="valueaddition1-view" icon={<FontAwesomeIcon icon={faDiceOne} />}>
                                        <Link to="/valueaddition1-view"><span>Val Addn1</span></Link>
                                    </Menu.Item>


                                    {/* <SubMenu key="valueaddition1" icon={<PicCenterOutlined />} title="Val Addn1">
                          <Menu.Item key="valueaddition1-form" icon={<PlusSquareOutlined />}>
                          <Link to="/valueaddition1-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="valueaddition1-view" icon={<EyeOutlined/>}>
                          <Link to="/valueaddition1-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}
                                    {/* <SubMenu key="valueaddition2" icon={<PicCenterOutlined />} title="Val Addn2">
                          <Menu.Item key="valueaddition2-form" icon={<PlusSquareOutlined />}>
                          <Link to="/valueaddition2-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="valueaddition2-view" icon={<EyeOutlined/>}>
                          <Link to="/valueaddition2-view"><span>View</span></Link>
                          </Menu.Item> */}
                                    {/* </SubMenu> */}

                                    <Menu.Item key="valueaddition2-view" icon={<FontAwesomeIcon icon={faDiceTwo} />}>
                                        <Link to="/valueaddition2-view"><span>Val Addn2</span></Link>
                                    </Menu.Item>

                                    {/* <SubMenu key="valueaddition3" icon={<PicCenterOutlined />} title="Val Addn3">
                          <Menu.Item key="valueaddition3-form" icon={<PlusSquareOutlined />}>
                          <Link to="/valueaddition3-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="valueaddition3-view" icon={<EyeOutlined/>}>
                          <Link to="/valueaddition3-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}

                                    <Menu.Item key="valueaddition3-view" icon={<FontAwesomeIcon icon={faDiceThree} />}>
                                        <Link to="/valueaddition3-view"><span>Val Addn3</span></Link>
                                    </Menu.Item>


                                    {/* <SubMenu key="valueaddition4" icon={<PicCenterOutlined />} title="Val Addn4">
                          <Menu.Item key="valueaddition4-form" icon={<PlusSquareOutlined />}>
                          <Link to="/valueaddition4-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="valueaddition4-view" icon={<EyeOutlined/>}>
                          <Link to="/valueaddition4-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}

                                    <Menu.Item key="valueaddition4-view" icon={<FontAwesomeIcon icon={faDiceFour} />}>
                                        <Link to="/valueaddition4-view"><span>Val Addn4</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="valueaddition5-view" icon={<FontAwesomeIcon icon={faDiceFive} />}>
                                        <Link to="/valueaddition5-view"><span>Val Addn5</span></Link>
                                    </Menu.Item>


                                    {/* <SubMenu key="bom" icon={<PicCenterOutlined />} title="BOM Yielding Parameters">
                          <Menu.Item key="bom-form" icon={<PlusSquareOutlined />}>
                          <Link to="/bom-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="bom-view" icon={<EyeOutlined/>}>
                          <Link to="/bom-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}

                                    {/* <SubMenu key="certificates" icon={<PicCenterOutlined />} title="certificates">
                          <Menu.Item key="certificates-form" icon={<PlusSquareOutlined />}>
                          <Link to="/certificates-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="certificates-view" icon={<EyeOutlined/>}>
                          <Link to="/certificates-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}


                                    {/* <SubMenu key="packingmethods" icon={<PicCenterOutlined />} title="Packing Methods">
                          <Menu.Item key="packingmethods-form" icon={<PlusSquareOutlined />}>
                          <Link to="/Packingmethods-form"><span>Add</span></Link>
                          </Menu.Item>
                          <Menu.Item key="packingmethods-view" icon={<EyeOutlined/>}>
                          <Link to="/Packingmethods-view"><span>View</span></Link>
                          </Menu.Item>
                          </SubMenu> */}

                                    {/* <SubMenu key="destination" icon={<PicCenterOutlined />} title="Destination">
                            <Menu.Item key="destination-form" icon={<PlusSquareOutlined />}>
                            <Link to="/destination-form"><span>Add</span></Link>
                            </Menu.Item>
                            <Menu.Item key="destination-view" icon={<EyeOutlined/>}>
                            <Link to="/destination-view"><span>View</span></Link>
                            </Menu.Item>
                        </SubMenu> */}

                                    {/* <SubMenu key="sub11" icon={<PicCenterOutlined />}  title="EndCustomer" >
                        <Menu.Item key="EndCustomerForm" icon={<PlusSquareOutlined />} >
                            <Link to="/EndCustomerForm" >
                            <span> form   </span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="EndCustomerView" icon={<EyeOutlined/>} >
                            <Link to="/EndCustomerview" >
                            <span> view  </span>
                            </Link>
                        </Menu.Item>
                          <Menu.Item key="sku-view" icon={<EyeOutlined/>}>
                          <Link to="/sku-view"><span>View</span></Link>
                          </Menu.Item>
                    </SubMenu>
                    {/* Sales Masters Ending */}
                                    <Menu.Item key="sku-view" icon={<PicCenterOutlined />}>
                                        <Link to="/sku-view"><span>Product SKU's</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="hsn-view" icon={<FontAwesomeIcon icon={faCode} />}>
                                        <Link to="/hsn-view"><span>HSN Code</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="rm_masters" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>Raw Material</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="hatcheries-view" icon={<PicCenterOutlined />}>
                                        <Link to="/hatcheries-view"><span>Hatcheries</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="hl-percentage-view" icon={<PicCenterOutlined />}>
                                        <Link to="/hl-percentage-view"><span>HL Percentages</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="suppliers-view" icon={<PicCenterOutlined />}>
                                        <Link to="/suppliers-view"><span>Farmers</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-tolerance-view" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-tolerance-view"><span>Rm Tolerance</span></Link>
                                    </Menu.Item>



                                </SubMenu>
                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="transport_masters" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>Transportation</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="vehicles" icon={<PicCenterOutlined />}>
                                        <Link to="/vehicles"><span>Vehicles</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }
                            {((
                                [
                                    EmployeeRolesEnum.ADMIN,
                                    EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                    EmployeeRolesEnum.HO_PACKAGING_MANAGER
                                ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <SubMenu
                                    key="procurement_masters" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>Packing</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="grn-rejection-reason-view" icon={<FontAwesomeIcon icon={faFileCircleQuestion} />}>
                                        <Link to="/grn-rejection-reason-view"><span>GRN Rejection Reason</span></Link>
                                    </Menu.Item>

                                    {(([
                                        EmployeeRolesEnum.ADMIN,
                                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                        EmployeeRolesEnum.HO_PACKAGING_MANAGER
                                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="item-category-view" icon={<FontAwesomeIcon icon={faNewspaper} />}>
                                                <Link to="/item-category-view"><span>Item Categories</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="item-sub-category-view" icon={<FontAwesomeIcon icon={faNetworkWired} />}>
                                                <Link to="/item-sub-category-view"><span>Item Sub Categories</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="sizes-view" icon={<FontAwesomeIcon icon={faRuler} />}>
                                                <Link to="/sizes-view"><span>Sizes</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="items-view" icon={<FontAwesomeIcon icon={faNewspaper} />}>
                                                <Link to="/items-view"><span>Items</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="vendorsView" icon={<FontAwesomeIcon icon={faUsersRays} />}>
                                                <Link to="/vendorsView"><span>Vendors</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="reasonsView" icon={<FontAwesomeIcon icon={faCommentSlash} />}>
                                                <Link to="/reasonsView"><span>Reasons</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="trimsView" icon={<PicCenterOutlined />}>
                                                <Link to="/trimsView"><span>Trims</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="types-grid" icon={<PicCenterOutlined />}>
                                                <Link to="/types-grid"><span>Types</span></Link>
                                            </Menu.Item>
                                        </>
                                    }
                                </SubMenu>
                            }


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.NAVTECH_WH) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                                <SubMenu
                                    key="warehouse_masters" icon={<FontAwesomeIcon icon={faWarehouse}/>}
                                    title={
                                        <span>
                                            <span>Warehouse</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="zone" icon={<FontAwesomeIcon icon={faSnowflake}/>}>
                                        <Link to="/zone"><span>Cold Storage</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="column" icon={<FontAwesomeIcon icon={faColumns}/>}>
                                        <Link to="/column"><span>Columns</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="level" icon={<PicCenterOutlined />}>
                                        <Link to="/level"><span>Levels</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="locations" icon={<PicCenterOutlined />}>
                                <Link to="/locations"><span>Locations</span></Link>
                            </Menu.Item> */}
                                    <Menu.Item key="pallet" icon={<FontAwesomeIcon icon={faPallet}/>}>
                                        <Link to="/pallet"><span>Pallets</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rack" icon={<InsertRowLeftOutlined/>}>
                                        <Link to="/rack-master-grid"><span>Racks</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rack-position" icon={<PicCenterOutlined />}>
                                        <Link to="/rack-position"><span>Rack Position</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="rack-endCustomer-mapping" icon={<PicCenterOutlined />}>
                                        <Link to='/rack-endCustomer-mapping'><span>Rack End Customer Mapping</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="pallet-capacity-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/pallet-capacity-grid"><span>Pallet Capacity</span></Link>
                                    </Menu.Item>


                                </SubMenu>
                            }

                            <SubMenu
                                key="masters_planning_module" icon={<DropboxOutlined />}
                                title={
                                    <span>
                                        <span>Planning</span>
                                    </span>
                                }
                            >

                                <Menu.Item key="resource-op-efficiency-view" icon={<ScheduleOutlined />}>
                                    <Link to="/resource-op-efficiency-view"><span>Resource Operation Efficiency</span></Link>
                                </Menu.Item>
                                <Menu.Item key="plant-capacity-form" icon={<ScheduleOutlined />}>
                                    <Link to="/plant-capacity-form"><span>Plant Capacity</span></Link>
                                </Menu.Item>

                            </SubMenu>
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="production" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>Production</span>
                                        </span>
                                    }
                                >

                                    <Menu.Item key="varient-operations-form" icon={<PicCenterOutlined />}>
                                        <Link to="/varient-operations-form"><span>Varient Operations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="workstation-category-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/workstation-category-grid"><span>Workstation Category</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="operations-view" icon={<PicCenterOutlined />}>
                                        <Link to="/operations-view"><span>Operations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="workstations-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/workstations-grid"><span>Workstations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="plant-operation-capacity-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/plant-operation-capacity-view"><span>plant-operation-capacity</span></Link>
                                    </Menu.Item>



                                </SubMenu>
                            }


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="qa_qc_masters" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>QA QC</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="qa-qc-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/qa-qc-grid"><span>QA QC Operations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="code-list-grid" icon={<ScheduleOutlined />}>
                                        <Link to="/code-list-grid"><span>Code List</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="code-list-print" icon={<ScheduleOutlined />}>
                                    <Link to="/code-list-print"><span>Code print</span></Link>
                                </Menu.Item> */}
                                </SubMenu>

                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="hrms_masters" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>HRMS</span>
                                        </span>
                                    }

                                >

                                    <Menu.Item key="/certifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/certifications-view"><span>Certifications</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/complaints-view" icon={<PicCenterOutlined />}>
                                        <Link to="/complaints-view"><span>Complaints</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="department-view" icon={<PicCenterOutlined />}>
                                        <Link to="/department-view"><span>Departments</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/designation-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/designation-grid"><span>Designation</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/educations-view" icon={<PicCenterOutlined />}>
                                        <Link to="/educations-view"><span>Education</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/employment-status-form" icon={<PicCenterOutlined />}>
                                        <Link to="/employment-status-form"><span>Employment Status </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/expenses-category-view" icon={<PicCenterOutlined />}>
                                        <Link to="/expenses-category-view"><span>Expenses Category</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/expenses-sub-category-view" icon={<PicCenterOutlined />}>
                                        <Link to="/expenses-sub-category-view"><span>Expenses Sub Category</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/holidays-calendar-view" icon={<PicCenterOutlined />}>
                                        <Link to="/holidays-calendar-view"><span>Holidays Calendar</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="id-proofs-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/id-proofs-grid"><span>Id Proofs</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="languages" icon={<PicCenterOutlined />}>
                                        <Link to="/languages"><span>Languages</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/loan-categories-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/loan-categories-grid"><span>Loan Categories</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/over-time-categories-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/over-time-categories-grid"><span>Over Time Categories</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/qualifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/qualifications-view"><span>Qualificaitons</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/relations-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/relations-grid"><span>Relations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="roles-view" icon={<PicCenterOutlined />}>
                                        <Link to="/roles-view"><span>Roles</span></Link>
                                    </Menu.Item>

                                    {/* <Menu.Item key="/exit-action-view" icon={<PicCenterOutlined />}>
                                        <Link to="/exit-action-view"><span>Exit Action</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="recruitment-mode-view" icon={<PicCenterOutlined />}>
                                        <Link to="/recruitment-mode-view"><span>Recruitment-Mode</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/skills-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/skills-grid"><span>Skills</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="/suggestion-view" icon={<PicCenterOutlined />}>
                                        <Link to="/suggestion-view"><span>Suggestions</span></Link>
                                    </Menu.Item> */}


                                    {/* <Menu.Item key="/profiles-view" icon={<PicCenterOutlined />}>
                                        <Link to="/profiles-view"><span>Recruitment Profile</span> </Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/notifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/notifications-view"><span>Recruitment Notification</span> </Link>
                                    </Menu.Item> */}

                                    <Menu.Item key="/types-of-leaves-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/types-of-leaves-grid"><span>Types Of Leaves</span></Link>
                                    </Menu.Item>



                                    {/* <Menu.Item key="/certifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/certifications-view"><span>Certifications</span></Link>
                                    </Menu.Item> */}


                                </SubMenu>



                            }

                        </SubMenu>
                    }

                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L1') ||(JSON.parse(localStorage.getItem('role'))==='L5'))  &&  */}
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SR_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_SALES_MANAGER)) &&
                        <SubMenu
                            key="sales_module" icon={<MoneyCollectOutlined />}
                            title={
                                <span>
                                    <span>Sales</span>
                                </span>
                            }
                        >
                            <Menu.Item key="saleorder-form" icon={<PlusSquareOutlined />}>
                                <Link to="/saleorder-form"><span>SO Creation</span></Link>
                            </Menu.Item>
                            {/* <Menu.Item key="allsaleorders-view" icon={<PicCenterOutlined />}>
                            <Link to="/allsaleorders-view"><span>Sale Orders</span></Link>
                        </Menu.Item> */}
                            {/* <Menu.Item key="so_view" icon={<TableOutlined />}>
                            <Link to="/saleorder-view"><span>SO View</span></Link>
                        </Menu.Item> */}
                            <Menu.Item key="saleorder-tracker" icon={<MonitorOutlined />}>
                                <Link to="/saleorder-tracker"><span>SO Tracker</span></Link>
                            </Menu.Item>

                        </SubMenu>
                    }

                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L2')) && */}
                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                        <SubMenu
                            key="procurement_module" icon={<DropboxOutlined />}
                            title={
                                <span>
                                    <span>Packing</span>
                                </span>
                            }
                        >
                            {/* <Menu.Item key="packing-dashboard" icon={<FundProjectionScreenOutlined />}>
                                <Link to="/packing-dashboard"><span>Dashboard</span></Link>
                            </Menu.Item> */}

                            {
                                (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <><Menu.Item key="allsaleorders-view" icon={<MonitorOutlined />}>
                                    <Link to="/allsaleorders-view"><span>BOM Tracker</span></Link>
                                </Menu.Item><Menu.Item key="packing-bom-report" icon={<FundProjectionScreenOutlined />}>
                                        <Link to="/packing-bom-report"><span>Packing BOM</span></Link>
                                    </Menu.Item></>
                            }



                            {
                                (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <>
                                    <Menu.Item key="purchase-order-grid" icon={<FilePptOutlined />}>
                                        <Link to="/purchase-order-grid"><span>PO</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="grn-form" icon={<ContainerOutlined />}>
                                        <Link to="/grn-grid"><span>GRN</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="grn-return-form" icon={<FileSyncOutlined />}>
                                        <Link to="/grn-return-grid"><span>GRN Return</span></Link>
                                    </Menu.Item>
                                </>
                            }




                            {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <>
                                    <Menu.Item key="stock-grid" icon={<GoldOutlined />}>
                                        <Link to="/stock-grid"><span>Stock</span></Link>
                                    </Menu.Item>
                                </>
                            }
                            {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <>
                                    <Menu.Item key="packing-stock-entry" icon={<ImportOutlined />}>
                                        <Link to="/packing-stock-entry"><span>Stock Entry</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="packing-product-conversion" icon={<InteractionFilled />}>
                                        <Link to="/packing-product-conversion"><span>Product Conversion</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="stock-transfer-grid" icon={<ExportOutlined />}>
                                        <Link to="/stock-transfer-grid"><span>Stock Transfer</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="cycle-checker" icon={<GroupOutlined />}>
                                        <Link to="/cycle-checker"><span>Cycle Checker</span></Link>
                                    </Menu.Item>

                                </>
                            }


                            {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <>
                                    <Menu.Item key="store-consumption-grid" icon={<ExportOutlined />}>
                                        <Link to="/store-consumption-grid"><span>Store Issues</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="store_return" icon={<FileSyncOutlined />}>
                                        <Link to="/store-return"><span>Store Return</span></Link>
                                    </Menu.Item>
                                </>
                            }

                        </SubMenu>
                    }
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="rm_proc_module" icon={<DropboxOutlined />}
                            title={
                                <span>
                                    <span>RM Procurement</span>
                                </span>
                            }
                        >
                            <Menu.Item key="rm-dashboard" icon={<ContainerOutlined />}>
                                <Link to="/rm-dashboard"><span>RM Dashboard</span></Link>
                            </Menu.Item>
                            <Menu.Item key="procurement-dashboard" icon={<ContainerOutlined />}>
                                <Link to="/procurement-dashboard"><span>Procurement Dashboard</span></Link>
                            </Menu.Item>

                            <Menu.Item key="indent-view" icon={<ContainerOutlined />}>
                                <Link to="/indent-view"><span>Indent</span></Link>
                            </Menu.Item>
                            <Menu.Item key="vehicle-assignment" icon={<ContainerOutlined />}>
                                <Link to="/vehicle-assignment"><span>Assign Vehicle</span></Link>
                            </Menu.Item>
                            <Menu.Item key="rm-grn-grid" icon={<ContainerOutlined />}>
                                <Link to="/rm-grn-grid"><span>GRN</span></Link>
                            </Menu.Item>
                            <Menu.Item key="bom-tracker-grid" icon={<ContainerOutlined />}>
                                <Link to="/bom-tracker-grid"><span>Bom Tracker</span></Link>
                            </Menu.Item>
                            <Menu.Item key="rm-indent-qty-limit-grid" icon={<ContainerOutlined />}>
                                <Link to="/rm-indent-qty-limit-grid"><span>Rm Indent Qty Limit</span></Link>
                            </Menu.Item>

                        </SubMenu>
                    }


                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="production" icon={<RiseOutlined />}
                            title={
                                <span>
                                    <span>Production</span>
                                </span>
                            }
                        >
                            <Menu.Item key="production-inventory-grid" icon={<ContainerOutlined />}>
                                <Link to="/production-inventory-grid"><span>RM Inventory</span></Link>
                            </Menu.Item>



                            <SubMenu
                                key="sub-plant-operations" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Stock Transfer</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="inventory-stock-transfer-grid" icon={<ContainerOutlined />}>
                                    <Link to="/inventory-stock-transfer-grid"><span>Send</span></Link>
                                </Menu.Item>
                                <Menu.Item key="sub-plant-operations-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/sub-plant-operations-grid"><span>Operations</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="sub-plant-val-addition-report" icon={<PicCenterOutlined />}>
                                    <Link to="/sub-plant-val-addition-report"><span>Sub Plant Val Addition Report</span></Link>
                                </Menu.Item>

                                <Menu.Item key="report-subplant-operations" icon={<PicCenterOutlined />}>
                                    <Link to="/report-subplant-operations"><span>Reporting</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="receive-subplant-stock" icon={<PicCenterOutlined />}>
                                    <Link to="/receive-subplant-stock"><span>Beheading to Deheading</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="receive-subplant-stock" icon={<PicCenterOutlined />}>
                                    <Link to="/receive-subplant-stock"><span>Receive</span></Link>
                                </Menu.Item>


                            </SubMenu>
                            <SubMenu
                                key="beheading" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Deheading</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="be-heading-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-dashboard"><span>Deheading Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="be-heading-inprogress-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-inprogress-inventory"><span>Deheading Work In-Progress</span></Link>
                                </Menu.Item>
                                <Menu.Item key="be-heading-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-inventory"><span>Deheading Inventory</span></Link>
                                </Menu.Item>

                                {/* <Menu.Item key="be-heading-sub-plant-history" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-sub-plant-history"><span>Sub Plant Operations</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="be-heading" icon={<ContainerOutlined />}>
                                <Link to="/be-heading"><span>Assign Rm Inventory To Beheading</span></Link>
                            </Menu.Item> */}
                            </SubMenu>

                            <SubMenu
                                key="grading" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Grading</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="grade-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/grade-dashboard"><span>Grading Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="assign-to-grading" icon={<ContainerOutlined />}>
                                    <Link to="/assign-to-grading"><span>Assign to Grading</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grade-reporting" icon={<ContainerOutlined />}>
                                    <Link to="/grade-reporting"><span>Grade Reporting</span></Link>
                                </Menu.Item>
                                <Menu.Item key="assign-so-to-grade" icon={<ContainerOutlined />}>
                                    <Link to="/assign-so-to-grade"><span>Assign SO to Grade</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grade-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grade-inventory"><span>Grading Inventory</span></Link>
                                </Menu.Item>
                                <Menu.Item key="yield-report" icon={<ContainerOutlined />}>
                                    <Link to="/yield-report"><span>Yield Report</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="valAddition" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Value addition</span>
                                    </span>
                                }
                            >
                                {/* <Menu.Item key="assign-to-val-addition" icon={<PicCenterOutlined />}>
                                <Link to="/assign-to-val-addition"><span>Val Addition dashboard</span></Link>
                            </Menu.Item> */}
                                <Menu.Item key="val-addition-grading-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-grading-dashboard"><span>Value Addition Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="val-addition-inventory-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-inventory-grid"><span>Value Addition Inventory</span></Link>
                                </Menu.Item>


                            </SubMenu>

                            {/* <Menu.Item key="soaking" icon={<ExperimentTwoTone />}>
                            <Link to="/soaking"><span>Soaking</span></Link>
                        </Menu.Item> */}
                            {/* </Menu.Item> */}
                            <SubMenu
                                key="soaking" icon={<ExperimentTwoTone />}
                                title={
                                    <span>
                                        <span>Soaking</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="soaking-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/soaking-dashboard"><span>Soaking Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="val-addition-soaking-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-soaking-grid"><span>Value Addition Inventory For Soaking</span></Link>
                                </Menu.Item>
                                <Menu.Item key="soaking-assignment-grid" icon={<ContainerOutlined />}>
                                    <Link to="/soaking-assignment-grid"><span>Soaking Inventory</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-soaking-for-freezing"><span>Assign Soaking for Freezing</span></Link>
                            </Menu.Item> */}
                                {/* <Menu.Item key="soaking-reporting" icon={<ContainerOutlined />}>
                                <Link to="/soaking-reporting"><span>Soaking Reporting</span></Link>
                            </Menu.Item> */}

                            </SubMenu>
                            <Menu.Item key="cooking-grid" icon={<ContainerOutlined />}>
                                <Link to="/cooking-grid"><span>Cooking</span></Link>
                            </Menu.Item>
                            <SubMenu
                                key="freezing" icon={<ExperimentTwoTone />}
                                title={
                                    <span>
                                        <span>Freezing</span>
                                    </span>
                                }
                            >

                                <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                                    <Link to="/assign-soaking-for-freezing"><span>Assigning for Freezing</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-for-freezing-form"><span>Assign Soaking for Freezing</span></Link>
                        </Menu.Item> */}
                            </SubMenu>
                            <SubMenu
                                key="rejections" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Rejections</span>
                                    </span>
                                }
                            >


                                <Menu.Item key="rejections-grid" icon={<ContainerOutlined />}>
                                    <Link to="/rejections-grid"><span>Rejections Inventory</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-for-freezing-form"><span>Assign Soaking for Freezing</span></Link>
                        </Menu.Item> */}
                            </SubMenu>
                        </SubMenu>
                    }

                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="qa-qc" icon={<RiseOutlined />}
                            title={
                                <span>
                                    <span>QA/QC</span>
                                </span>
                            }
                        >
                            <Menu.Item key="qa-qc-sample-test-grid" icon={<ContainerOutlined />}>
                                <Link to="/qa-qc-sample-test-grid"><span>QA/QC</span></Link>
                            </Menu.Item>
                            <Menu.Item key="labelling-grid" icon={<ContainerOutlined />}>
                                <Link to="labelling-grid"><span>Labelling</span></Link>
                            </Menu.Item>


                            <Menu.Item key="/fg-inspection-print" icon={<ContainerOutlined />}>
                                <Link to="/fg-inspection-print"><span>Fg-inspection </span></Link>
                            </Menu.Item>
                            <Menu.Item key="/inspection-print" icon={<PicCenterOutlined />}>
                                <Link to="/inspection-print"><span >Product-inspection </span></Link>
                            </Menu.Item>
                            <Menu.Item key="/pd-qaqc-print" icon={<PicCenterOutlined />}>
                                <Link to="/pd-qaqc-print"><span >PD </span></Link>
                            </Menu.Item>
                            <Menu.Item key="/metal-detection-grid" icon={<PicCenterOutlined />}>
                                <Link to="/metal-detection-grid"><span >Metal Detection</span></Link>
                            </Menu.Item>
                            <Menu.Item key="so-inspection" icon={<PicCenterOutlined />}>
                                <Link to="/so-inspection"><span>SO Inspection</span></Link>
                            </Menu.Item>
                            <Menu.Item key="code-list-main-grid" icon={<ScheduleOutlined />}>
                                    <Link to="/code-list-main-grid"><span>Code List Allocation</span></Link>
                                </Menu.Item>
                        </SubMenu>
                    }


                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER, EmployeeRolesEnum.WAREHOUSE_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                        <SubMenu
                            key="warehouseManagement" icon={<FontAwesomeIcon icon={faWarehouse}/>}
                            title={
                                <span>
                                    <span>Warehouse</span>
                                </span>
                            }
                        >
                            {/* <Menu.Item key="reporting" icon={<DownloadOutlined />}>
                                <Link to="/reporting"><span>Stock In</span></Link>
                            </Menu.Item> */}
                            <Menu.Item key="reporting" icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}>
                                <Link to="/stock-in"><span>Stock In</span></Link>
                            </Menu.Item>
                            <Menu.Item key="stock-in-reverse" icon={<FontAwesomeIcon icon={faArrowsRotate} />}>
                                <Link to="/stock-in-reverse"><span>Stock In Reverse</span></Link>
                            </Menu.Item>
                            <Menu.Item key="fgstock" icon={<FontAwesomeIcon icon={faBoxesStacked} />}>
                                <Link to="/fg-stock"><span>Stock</span></Link>
                            </Menu.Item>
                            <Menu.Item key="stock-out-grid" icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}>
                                <Link to="/stock-out-grid"><span>Stock Out</span></Link>
                            </Menu.Item>
                            <Menu.Item key="reserve-racks" icon={<InsertRowLeftOutlined />}>
                                <Link to="/reserve-racks"><span>Reserve Racks</span></Link>
                            </Menu.Item>
                            <Menu.Item key="reprocess-repacking" icon={<FontAwesomeIcon icon={faBoxOpen} />}>
                                <Link to="/reprocess-repacking"><span>Reprocess & Repacking</span></Link>
                            </Menu.Item>
                            <Menu.Item key="fg-stock-transfer" icon={<FontAwesomeIcon icon={faCartFlatbedSuitcase} />}>
                                <Link to="/fg-stock-transfer"><span>Fg Stock transfer</span></Link>
                            </Menu.Item>





                            {/* <Menu.Item key="dispatch-list-grid" icon={<DownloadOutlined />}>
                                <Link to="/dispatch-list-grid"><span>Dispatch List</span></Link>
                            </Menu.Item> */}
                        </SubMenu>
                    }
                    {/* } */}
                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L3')) && */}
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                        <SubMenu
                            key="logistics" icon={<FontAwesomeIcon icon={faTruckFast}/>}
                            title={
                                <span>
                                    <span>Logistics</span>
                                </span>
                            }
                        >
                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&

                                <Menu.Item key="container-register-grid" icon={<FontAwesomeIcon icon={faTruckLoading}/>} >
                                    <Link to="/container-register-grid"><span>Container Register</span></Link>
                                </Menu.Item>
                            }

                            {
                                <Menu.Item key="container-report" icon={<FontAwesomeIcon icon={faTruckPickup}/>}>
                                    <Link to="/container-report"><span>Container Report</span></Link>
                                </Menu.Item>
                            }

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&

                                <Menu.Item key="bl-status-grid" icon={<BookOutlined />}>
                                    <Link to="/bl-status-grid"><span>Bill of Lading</span></Link>
                                </Menu.Item>
                            }

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                                <Menu.Item key="invoice-grid" icon={<FontAwesomeIcon icon={faFileInvoice}/>}>
                                    <Link to="/invoice-grid"><span>Invoice</span></Link>
                                </Menu.Item>
                            }

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                                <Menu.Item key="document-register" icon={<FontAwesomeIcon icon={faFileLines}/>}>
                                    <Link to="/document-register"><span>Document Register</span></Link>
                                </Menu.Item>
                            }


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                                <Menu.Item key="document-approval" icon={<FontAwesomeIcon icon={faFileCircleCheck}/>}>
                                    <Link to="/document-approval"><span>Documents Approval</span></Link>
                                </Menu.Item>
                            }

                            <Menu.Item key="log-book" icon={<FontAwesomeIcon icon={faBook}/>}>
                                <Link to="/log-book"><span>Log Book</span></Link>
                            </Menu.Item>



                            {/* {((JSON.parse(localStorage.getItem('role'))==='ADMIN')||(JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.OPERATIONS_MANAGER) ||(JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.OPERATIONS_EXECUTIVE)||(JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.DOCUMENTATION_MANAGER) ||(JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) )  &&
                        <Menu.Item key="upload-insurance" icon={<CloudUploadOutlined />}> <Link to="/upload-insurance"><span>Upload Insurance</span></Link>
                        </Menu.Item>
                        } */}

                            {/* <Menu.Item key="upload-insurance" icon={<CloudUploadOutlined />}>
                            <Link to="/upload-insurance"><span>Upload Insurance</span></Link>
                        </Menu.Item>


                         <Menu.Item key="cus-invoice-detail-view" icon={<FileProtectOutlined />}>
                            <Link to="/cus-invoice-detail-view"><span>Cus invoice</span></Link>
                        </Menu.Item>
                        <Menu.Item key="plant-invoice" icon={<FileProtectOutlined />}>
                            <Link to="/plant-invoice"><span>Plant invoice</span></Link>
                        </Menu.Item>
                        <Menu.Item key="plant-packing-list" icon={<FileProtectOutlined />}>
                            <Link to="/plant-packing-list"><span>Plant Packing List (Pre Loading)</span></Link>
                        </Menu.Item>  */}

                            {/* <Menu.Item key="isf-worksheet" icon={<FileProtectOutlined />}>
                            <Link to="/isf-worksheet"><span>Isf-Worksheet(USA)</span></Link>
                        </Menu.Item> */}
                            {/* <Menu.Item key="common-invoice-detail-view" icon={<FileProtectOutlined />}>
                            <Link to="/common-invoice-detail-view"><span>Common invoice</span></Link>
                        </Menu.Item>
                        <Menu.Item key="plant-packing-list-view" icon={<FileProtectOutlined />}>
                            <Link to="/plant-packing-list-view"><span>Plant Packing List</span></Link>
                        </Menu.Item>

                        <Menu.Item key="common-packing-list-view" icon={<FileProtectOutlined />}>
                            <Link to="/common-packing-list-view"><span>Common Packing List</span></Link>
                        </Menu.Item>


                        <Menu.Item key="shipping-instructions-view" icon={<FileProtectOutlined />}>
                            <Link to="/shipping-instructions-view"><span>Shipping Instructions</span></Link>
                        </Menu.Item>

                        <Menu.Item key="freigst-invoice" icon={<FileProtectOutlined />}>
                            <Link to="/freigst-invoice"><span>Freigst Invoice</span></Link>
                        </Menu.Item>

                        <Menu.Item key="commercial-packing-list-view" icon={<FileProtectOutlined />}>
                            <Link to="/commercial-packing-list-view"><span>Commercial Packing List</span></Link>
                        </Menu.Item>

                        <Menu.Item key="commercial-invoice-view" icon={<FileProtectOutlined />}>
                            <Link to="/commercial-invoice-view"><span>Commercial Invoice</span></Link>
                        </Menu.Item> */}


                        </SubMenu>
                    }



                    {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="inspection" icon={<DropboxOutlined />}
                            title={
                                <span>
                                    <span>Inspection</span>
                                </span>
                            }
                        >
                            <Menu.Item key="so-inspection" icon={<PicCenterOutlined />}>
                                <Link to="/so-inspection"><span>SO Inspection</span></Link>
                            </Menu.Item>
                        </SubMenu>
                    } */}
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="hrms" icon={<DropboxOutlined />}
                            title={
                                <span>
                                    <span>HRMS</span>
                                </span>
                            }
                        >
                            <Menu.Item key="HRMS-employee_details-view" icon={<PicCenterOutlined />}>
                                <Link to="/HRMS-employee_details-view"><span>Employees</span></Link>
                            </Menu.Item>
                            <SubMenu key="leave-management" icon={<MoneyCollectOutlined />}
                                title={
                                    <span>
                                        <span>Leave Management</span>
                                    </span>
                                }>
                                {/* <Menu.Item key="/types-of-leaves-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/types-of-leaves-grid"><span>Types Of Leaves</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="/employee-leaves-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-leaves-grid"><span>Employee Leaves</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/apply-for-leaves" icon={<PicCenterOutlined />}>
                                    <Link to="/apply-for-leaves"><span>Apply for Leaves</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/leave-approval" icon={<PicCenterOutlined />}>
                                    <Link to="/leave-approval"><span>Leave Approval</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu key=" recruitment" icon={<MoneyCollectOutlined />}
                                title={
                                    <span>
                                        <span> Recruitment</span>
                                    </span>
                                }>
                                {/* <Menu.Item key="/job-notifications-view" icon={<PicCenterOutlined />}>
                                    <Link to="/job-notifications-view"><span>Job Notification </span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="/notifications-view" icon={<PicCenterOutlined />}>
                                    <Link to="/notifications-view"><span>Recruitment Notification</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/profiles-view" icon={<PicCenterOutlined />}>
                                    <Link to="/profiles-view"><span>Recruitment Profile</span> </Link>
                                </Menu.Item>

                                <Menu.Item key="/interview-view" icon={<PicCenterOutlined />}>
                                    <Link to="/interview-view"><span>Interview</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/activities-view" icon={<PicCenterOutlined />}>
                                    <Link to="/activities-view"><span>Recruitment Activities</span> </Link>
                                </Menu.Item>




                            </SubMenu>
                            <SubMenu key="employee-actions" icon={<MoneyCollectOutlined />}
                                title={
                                    <span>
                                        <span>Employee Actions</span>
                                    </span>
                                }>

                                <Menu.Item key="designationaction-view" icon={<PicCenterOutlined />}>
                                    <Link to="/designationaction-view"><span>Designation Action</span></Link>
                                </Menu.Item>

                                <Menu.Item key="/exit-action-view" icon={<PicCenterOutlined />}>
                                    <Link to="/exit-action-view"><span>Exit Action</span></Link>
                                </Menu.Item>

                                <Menu.Item key="transfer-action-view" icon={<PicCenterOutlined />}>
                                    <Link to="/transfer-action-view"><span>Trasfer Action</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            <Menu.Item key="/expenses-view" icon={<PicCenterOutlined />}>
                                <Link to="/expenses-view"><span>Expenses </span></Link>
                            </Menu.Item>
                            <Menu.Item key="/suggestion-view" icon={<PicCenterOutlined />}>
                                <Link to="/suggestion-view"><span>Suggestions</span></Link>
                            </Menu.Item>
                        </SubMenu>
                    }
                    {/* } */}
                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L1')) && */}
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="reports" icon={<EditOutlined />}
                            title={
                                <span>
                                    <span>Reports</span>
                                </span>
                            }
                        >

                            <SubMenu
                                key="SO" icon={<DropboxOutlined />}
                                title={
                                    <span>
                                        <span>SO</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="sale-order-report" icon={<PicCenterOutlined />}>
                                    <Link to="/sale-otder-report"><span>Sale Order Report</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="end-customer-wise-so-report" icon={<PicCenterOutlined />}>
                                    <Link to="/end-customer-wise-so-report"><span>End customer Wise SO Report</span></Link>
                                </Menu.Item> */}
                            </SubMenu>

                            <SubMenu
                                key="Packing" icon={<DropboxOutlined />}
                                title={
                                    <span>
                                        <span>Packing</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="packing-bom-reprt" icon={<PicCenterOutlined />}>
                                    <Link to="/packing-bom-reprt"><span>Packing Bom Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="purchase-order-report" icon={<PicCenterOutlined />}>
                                    <Link to="/purchase-order-report"><span>Purchase Order Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="stock-report" icon={<PicCenterOutlined />}>
                                    <Link to="/stock-report"><span>Stock Report</span></Link>
                                </Menu.Item>

                                <Menu.Item key="grn-report" icon={<PicCenterOutlined />}>
                                    <Link to="/grn-report"><span>GRN Report</span></Link>
                                </Menu.Item>

                                {/* <Menu.Item key="so-packing-status-report" icon={<PicCenterOutlined />}>
                                    <Link to="/so-packing-report"><span>So Packing Status Report</span></Link>
                                </Menu.Item> */}

                                <Menu.Item key="store-consumption-report" icon={<PicCenterOutlined />}>
                                    <Link to="/store-consumption-report"><span>Store Consumption Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="so-packing-status" icon={<PicCenterOutlined />}>
                                    <Link to="/so-packing-status"><span>SO Packing Status Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="store-return-req" icon={<PicCenterOutlined />}>
                                    <Link to="/store-return-req"><span>Store Return Report</span></Link>
                                </Menu.Item>
                            </SubMenu>


                            <SubMenu
                                key="RM" icon={<DropboxOutlined />}
                                title={
                                    <span>
                                        <span>RM</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="rm-procurement-report" icon={<PicCenterOutlined />}>
                                    <Link to="/rm-procurement-report"><span>RM Procurement Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grn-abstract-report-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/grn-abstract-report-grid"><span>Grn Abstract Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="indent-report" icon={<PicCenterOutlined />}>
                                    <Link to="/indent-report"><span>Indent Report</span></Link>
                                </Menu.Item>
                            </SubMenu>


                            <SubMenu
                                key="Production" icon={<DropboxOutlined />}
                                title={
                                    <span>
                                        <span>Production</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="/lot-tracking-report" icon={<PicCenterOutlined />}>
                                    <Link to="/lot-tracking-report"><span>Lot Tracking</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/operations-register" icon={<PicCenterOutlined />}>
                                    <Link to="/operations-register"><span>Operations Register</span></Link>
                                </Menu.Item>

                            </SubMenu>

                            <SubMenu
                                key="Warehouse" icon={<DropboxOutlined />}
                                title={
                                    <span>
                                        <span>Warehouse</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="/stock-report-warehouse" icon={<PicCenterOutlined />}>
                                    <Link to="/stock-report-warehouse"><span>Stock Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/stock-in-transactions" icon={<PicCenterOutlined />}>
                                    <Link to="/stock-in-transactions"><span>Stock in Transactions</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/stock-out-transaction" icon={<PicCenterOutlined />}>
                                    <Link to="/stock-out-transaction"><span>Stock Out Transactions</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/stock-summary-report" icon={<PicCenterOutlined />}>
                                    <Link to="/stock-summary-report"><span>Stock Summary Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/fg-stock-report" icon={<PicCenterOutlined />}>
                                    <Link to="/fg-stock-report"><span>FG Stock Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/shipment-status-report" icon={<PicCenterOutlined />}>
                                    <Link to="/shipment-status-report"><span>Shipment Status Report</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/dummy-packing-report" icon={<PicCenterOutlined />}>
                                    <Link to="/dummy-packing-report"><span>Dummy Packing Report</span></Link>
                                </Menu.Item>



                            </SubMenu>






                        </SubMenu>
                    }
                    {/* <SubMenu
                        key="inspection" icon={<EditOutlined />}
                        title={
                            <span>
                                <span>Inspection</span>
                            </span>
                        }
                    >
                        <Menu.Item key="so-inspection" icon={<PicCenterOutlined />}>
                            <Link to="/so-inspection"><span>SO Inspection</span></Link>
                        </Menu.Item>
                    </SubMenu> */}
                    {/* } */}

                </Menu>
            </Sider>


            <Layout
                style={{ marginLeft: collapsed ? 80 : 230 }}
            >

                <Header style={{
                    background: '#fff',
                    padding: 0
                }} className='noprint' >

                    <div className="ant-pro-global-header">
                        <div className="samllLogo">
                            <img style={{ display: collapsed ? 'block' : 'none' }} src={logo} />
                        </div>
                        <span className="ant-pro-global-header-trigger">
                            <MenuFoldOutlined
                                className="trigger"
                                type={collapsed ? 'menu-unfold' : 'menu-unfold'}
                                onClick={toggle}
                            />
                        </span>

                        <span>

                            <Button type="primary" style={{ float: 'right' }} onClick={logOut} ><ExportOutlined /><span className="l-rem">logout</span></Button>
                        </span>
                        <span ><Button style={{ float: 'right', border: 'white' }}>Hello! {username === '' ? user_name_local : props.user.user_data.username}</Button></span>

                        <span>
                            <Avatar icon={<UserOutlined />} />
                        </span>



                        {/* Advanced Search
                        <span> <Search
                            placeholder="Search here"
                            onSearch={value => console.log(value)}
                            style={{ width: 200, float: 'right', marginRight: '5%' }}
                        />
                        </span> */}

                    </div>

                </Header>

                <Content
                    style={{
                        margin: '5px 5px',
                        padding: 8,
                        background: '#fff',
                        minHeight: 280,
                        overflow: 'scroll',
                    }}
                >
                    <Route exact path="/department-view" component={DepartmentsGrid} />
                    <Route exact path="/department-form" render={props => <DepartmentsForm departmentData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDepartment={(undefined) => { }}
                    />} />
                    <Route exact path="/taxes-view" component={TaxesGrid} />
                    <Route exact path="/taxes-form" render={props => <TaxesForm taxesData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateTax={(undefined) => { }}
                    />} />
                    <Route exact path="/Currencies-view" component={CurrenciesGrid} />
                    <Route exact path="/Currencies-form" render={props => <CurrenciesForm currencyData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }} />}
                    />
                    <Route exact path="/Countries-view" component={CountriesGrid} />
                    <Route exact path="/Countries-form" render={props => <CountriesForm countryData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }} />}
                    />
                   <Route exact path="/DownTimeReason-view" component={DowntimeReasonGrid} />
                    <Route exact path="/DowntimeReason-form" render={props => <DowntimeReasonForm downtimereasonData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }} />}
                    />
                   
                    <Route exact path="/customers-view" component={CustomersGrid} />
                    <Route exact path="/customers-form" render={props => <CustomersForm customersData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }} />}
                    />
                    <Route exact path="/Grades-view" component={GradeGrid} />
                    <Route exact path="/Grades-form" render={props => <GradeForm gradesData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateGrade={(undefined) => { }}
                    />} />
                    <Route exact path="/HRMS-employee_details-view" component={HrmsEmployeeDetailsGrid} />
                    <Route exact path="/HRMS-employee_details-form" render={props => <HrmsEmployeeDetailsForm hrmsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />
                    <Route exact path="/designation-action-form" component={DesignationActionForm} />
                    <Route exact path="/designationaction-view" component={DesignationActionGrid} />
                    {/* <Route exact path="/valueaddition5-view" component={TypeOfValueAddition5Grid} />
                    <Route exact path="/valueaddition5-form" render={props => <TypeOfValueAddition5Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} /> */}
                    <Route exact path="/plant-operation-capacity-form" component={PlantOperationCapacityForm} />
                    <Route exact path="/plant-operation-capacity-view" component={PlantOperationCapacityGrid} />
                    <Route exact path="/grade-suggestion" component={GradeSuggestionFrom} />
                    <Route exact path="/valueaddition5-view" component={TypeOfValueAddition5Grid} />
                    <Route exact path="/valueaddition5-form" render={props => <TypeOfValueAddition5Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} />
                    <Route exact path="/Payment-modes-view" component={PaymentModesGrid} />
                    <Route exact path="/Payment-modes-form" render={props => <PaymentModesForm paymentmodeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePaymentmode={(undefined) => { }}
                    />} />
                    <Route exact path="/payment-terms-view" component={PaymentTermsGrid} />
                    <Route exact path="/payment-terms-form" render={props => <PaymentTermsForm paymentTermsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />
                    <Route exact path="/delivery-terms-view" component={DeliveryTermsGrid} />
                    <Route exact path="/delivery-terms-form" render={props => <DeliveryTermsForm deliverytermsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />
                    <Route exact path="/shipping-terms-view" component={ShippingTermsGrid} />
                    <Route exact path="/shipping-terms-form" render={props => <ShippingTermsForm shippingtermsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />

                    <Route exact path="/UOMs-view" component={UomsGrid} />
                    <Route exact path="/UOMs-form" render={props => <UomsForm uomsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }}
                    />} />

                    {/* <Route exact path="/unitcode-view" component={UnitCodeGrid} />
                    <Route exact path="/unitcode-form" component={UnitCodeForm} /> */}

                    <Route exact path="/saleorderprocesstypes-view" component={SaleOrderProcessTypesGrid} />
                    <Route exact path="/saleorderprocesstypes-form" render={props => <SaleOrderProcessTypesForm saleorderData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />

                    <Route exact path="/sale-order-types-view" component={SaleOrderTypesGrid} />
                    <Route exact path="/sale-order-types-form" render={props => <SaleOrderTypesForm SaleOrderTypeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }}
                    />} />
                    <Route exact path="/Products-view" component={ProductsGrid} />
                    <Route exact path="/Products-form" render={props => <ProductsForm productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} />
                    <Route exact path="/upload-insurance" component={InsuranceUpload} />

                    <Route exact path="/valueaddition1-view" component={TypeOfValueAddition1Grid} />
                    <Route exact path="/valueaddition1-form" render={props => <TypeOfValueAddition1Form type1Data={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateType1={(undefined) => { }}
                    />} />
                    <Route exact path="/valueaddition2-view" component={TypeOfValueAddition2Grid} />
                    <Route exact path="/valueaddition2-form" render={props => <TypeOfValueAddition2Form TypesOfValueAddition2Data={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateTypesOfValueAddition2Dto={(undefined) => { }}
                    />} />

                    <Route exact path="/valueaddition3-view" component={TypeOfValueAddition3Grid} />
                    <Route exact path="/valueaddition3-form" render={props => <TypeOfValueAddition3Form TypesOfValueAddition3Data={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateTypesOfValueAddition3Dto={(undefined) => { }}
                    />} />

                    <Route exact path="/saleordertypes-view" component={SaleOrderTypesGrid} />
                    <Route exact path="/saleordertypes-form" render={props => <SaleOrderTypesForm SaleOrderTypeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }}
                    />} />
                    <Route exact path="/valueaddition4-view" component={TypeOfValueAddition4Grid} />
                    <Route exact path="/valueaddition4-form" render={props => <TypeOfValueAddition4Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} />

                    <Route exact path="/certificates-view" component={CertificationsGrid} />
                    <Route exact path="/certificates-form" render={props => <CertificationsForm certificationData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateCertification={(undefined) => { }}
                    />} />
                    {/* <Route exact path="/saleorderdetailview" component={SaleOrderDetailViewGrid} /> */}
                    <Route exact path="/Packingmethods-view" component={PackingMethodsGrid} />
                    <Route exact path="/Packingmethods-form" render={props => <PackingMehodsForm packingMehodData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePackingMethod={(undefined) => { }}
                    />} />
                    <Route exact path="/saleorder-detail-view" render={props => <SaleOrderDetailViewPages />} />
                    <Route exact path="/saleorder-tracker" component={SaleOrderTrackingReportPages} />
                    <Route exact path="/end-customer-wise-so-report" component={EndCustomerSoReport} />
                    <Route exact path="/so-track" component={SaleOrderTrackingReportPages} />

                    <Route exact path="/destination-view" component={DestinationGrid} />
                    {/* <Route exact path="/destination-form" component={DestinationForm} /> */}
                    <Route exact path="/EndCustomerform" render={props => <EndCustomersForm endCustomersData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined => { })}
                    />} />
                    <Route exact path="/EndCustomerview" component={EndCustomerGrid} />


                    <Route exact path="/saleorder-form" render={props => <SoDesignForm saleOrderData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                    //   updateSaleOrder={(undefined)=>{}}
                    />}
                    />
                    <Route exact path="/sku-view" component={SkuGrid} />
                    <Route exact path="/sku-form" render={props => <SkuForm skuData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateSku={(undefined => { })}
                    />} />
                    <Route exact path="/hsn-view" component={HsnCodesGrid} />
                    <Route exact path="/hsn-form" render={props => <HsnCodesForm hsnData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateHsn={(undefined => { })}
                    />} />
                    <Route exact path="/saleorder-view" component={SoDesignGrid} />
                    <Route exact path="/typeofFood-form" render={props => <TypeOfFoodForm foodTypeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined => { })}
                    />} />


                    <Route exact path="/typeofFood-view" component={TypeOfFoodGrid} />


                    <Route exact path="/unitcode-view" component={UnitCodeGrid} />
                    <Route exact path="/unitcode-form" render={props => <UnitCodeForm unitcodeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateUnitcode={(undefined => { })}
                    />} />


                    <Route exact path="/vehicles" component={VehicleMasterGrid} />
                    <Route exact path="/vehicles-form" component={VehicleMasterForm} />





                    <Route exact path="/suppliers-view" component={SuppliersGrid} />
                    <Route exact path="/suppliers-form" render={props => <SuppliersForm
                        supplierData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateSupplier={(undefined => { })}
                    />
                    } />

                    <Route exact path="/hl-percentage-view" component={HlPercentagesGrid} />
                    <Route exact path="/hl-percentages-form" render={props => <HlPercentagesForm
                        hlpercentagesData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateHLpercentages={(undefined => { })}
                    />
                    } />
                    <Route exact path="/hatcheries-view" component={HatcheriesGrid} />
                    <Route exact path="/hatcheries-form" render={props => <HatcheriesForm
                        hatcheryData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateHatchery={(undefined => { })}
                    />
                    } />
                    <Route exact path="/rm-tolerance-view" component={RmToleranceGrid} />
                    <Route exact path="/rm-tolerance-form" render={props => <RmToleranceForm
                        rmToleranceData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateRmTolerance={(undefined => { })}
                    />
                    } />


                    <Route exact path="/level" component={LevelGrid} />
                    <Route exact path="/level-form" render={props => <LevelForm levelData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateLevel={(undefined => { })}
                    />
                    } />
                    <Route exact path="/pallet" component={PalletGrid} />
                    <Route exact path="/pallet-form" render={props => <PalletForm palletData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePallet={(undefined => { })}
                    />
                    } />
                    <Route exact path="/zone" component={ZoneGrid} />
                    <Route exact path="/zone-form" render={props => <ZoneForm zoneData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateZone={(undefined => { })}
                    />
                    } />
                    <Route exact path="/rack-position" component={RackGrid} />
                    <Route exact path="/rack-form" render={props => <RackForm rackData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateRack={(undefined => { })}
                    />
                    } />
                    <Route exact path="/rack-master-grid" component={RacksMasterGrid} />
                    <Route exact path="/pallet-capacity-grid" component={PalletCapacityGrid} />
                    <Route exact path="/pallet-capacity-form" render={props => <PalletCapacityForm palletCapacityData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePalletCapacity={(undefined => { })}
                    />
                    } />

                    <Route exact path="/rack-master-form" render={props => <RacksMasterForm rackData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateRack={(undefined => { })}
                    />
                    } />
                    <Route exact path="/locations" component={LocationsGrid} />
                    <Route exact path="/locations-form" render={props => <LocationsForm
                        locationsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateLocations={(undefined => { })}
                    />
                    } />
                    <Route exact path="/column" component={ColumnsGrid} />
                    <Route exact path="/columns-form" render={props => <ColumnsForm
                        columnData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateColumn={(undefined => { })}
                    />
                    } />
                    <Route exact path="/rack-endCustomer-mapping" component={RackEndcustomerMappingGrid} />
                    <Route exact path="/rack-endCustomers-mapping-form" component={RackEndcustomerMappingForm} />



                    <Route exact path="/roles-view" component={RolesGrid} />
                    <Route exact path="/roles-form" render={props => <RolesForm roleData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateRole={(undefined => { })} />
                    } />
                    <Route exact path="/recruitment-mode-view" component={RecruitmentGrid} />
                    <Route exact path="/recruitment-mode-form" render={props => <RecruitmentForm recruitmentData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateRecruitment={(undefined => { })} />
                    } />

                    <Route exact path="/transfer-action-view" component={TransferActionGrid} />
                    <Route exact path="/transfer-action-form" component={TransferActionForm} />
                    {/* <Route exact path="/valueaddition5-view" component={TypeOfValueAddition5Grid} /> */}
                    {/* <Route exact path="/valueaddition5-form" render={props => <TypeOfValueAddition5Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} /> */}




                    <Route exact path="/expenses-form" component={ExpensesForm} />
                    <Route exact path="/expenses-view" component={ExpensesGrid} />

                    <Route exact path="/profiles-form" component={ProfilesForm} />
                    <Route exact path="/profiles-view" component={ProfilesGrid} />

                    <Route exact path="/notifications-form" component={NotificationsForm} />
                    <Route exact path="/notifications-view" component={NotificationsGrid} />

                    <Route exact path="/activities-form" component={ActivitiesForm} />
                    <Route exact path="/activities-view" component={ActivitiesGrid} />


                    {/* <Route exact path="/notifications-view" component={NotificationsGrid} /> */}

                    {/* <Route exact path="/languages-form" component={LanguagesForm} />
                    <Route exact path="/languages" component={LanguagesGrid} /> */}

                    <Route exact path="/holidays-calendar-form" component={HolidaysCalender} />
                    <Route exact path="/holidays-calendar-view" component={HolidaysCalenderGrid} />


                    <Route exact path="/employment-status-view" component={EmploymentStatusForm} />
                    <Route exact path="/employment-status-form" component={EmploymentStatusGrid} />


                    {/* <Route exact path="/valueaddition5-view" component={TypeOfValueAddition5Grid} />
                    <Route exact path="/valueaddition5-form" render={props => <TypeOfValueAddition5Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} /> */}

                    <Route exact path="/destination-form" render={props => <DestinationForm destinatonData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />



                    {/* <Route exact path="/unitcode-view" component={UnitCodeGrid} />
                    <Route exact path="/unitcode-form" render={props => <UnitCodeForm unitcodeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateUnitcode={(undefined => { })}
                    />} /> */}





                    {/* <Route exact path="/item-category-view" component={ItemCategoriesGrid} /> */}
                    {/* <Route exact path="/item-category-form" render={props => <ItemCategoriesForm itemcategoryData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined => { })}
                    />} /> */}





                    <Route exact path="/item-damage-reasons-view" component={ItemDamageReasonsGrid} />
                    <Route exact path="/item-damage-reasons-form" render={props => <ItemDamageReasonsForm itemdamagereasonsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined => { })} />
                    } />






                    <Route exact path="/invoice-form" render={props => <Invoice
                        isUpdate={false}

                    />
                    } />

                    {/* <Route exact path="/saleorder-bom" render={props => <BomParameter saleOrderId={0}
                    />} /> */}
                    <Route exact path="/saleorder-bom" component={BomParameter} />
                    <Route exact path="/saleorder-bom-grid" component={BomParameterGrid} />
                    <Route exact path='/bom-detail-view' component={BomParameterDetailView} />

                    <Route exact path="/reporting" component={ReportingForm} />
                    <Route exact path="/stock-in" component={StockInForm} />
                    <Route exact path="/fg-stock" component={StockGrid} />
                    <Route exact path="/sale-otder-report" component={SaleDetailsReport} />
                    <Route exact path="/purchase-order-report" component={PurchaseOrderReport} />
                    <Route exact path="/so-packing-status" component={SoPackingStatus} />
                    <Route exact path="/store-return-req" component={StoreReturnReport} />
                    <Route exact path="/packing-bom-reprt" component={PackingBomReport} />
                    <Route exact path="/store-consumption-report" component={StoreConsumptionReport} />
                    <Route exact path="/indent-report" component={IndentReport} />
                    <Route exact path="/stock-report" component={StockReport} />
                    <Route exact path="/operationlog-books-register" component={OperationsRegister} />
                    <Route exact path="/grn-report" component={GrnReportGrid} />



                    <Route exact path="/fh-dashboard-grid" component={FactoryHeadDashboardGrid} />
                    <Route exact path="/dashboard" component={Dashboard} />
                    <Route exact path="/document-approval" component={DocumentsApprovalForm} />
                    <Route exact path="/container-register-grid" component={ContainerRegisterGrid} />
                    <Route exact path="/container-report" component={ContainerReport} />
                    <Route exact path="/capture-gross-weight" component={CaptureGrossWeightForm} />
                    <Route exact path="/container-register-form" component={ContainerRegister} />
                    <Route exact path="/container-booking" component={BookContainer} />
                    <Route exact path="/container-dispatch-to-plant" component={DispatchToPlant} />
                    <Route exact path="/assign-so" component={AssignSo} />
                    <Route exact path="/fill-seal-info" component={FillSealInfo} />
                    <Route exact path="/bl-status-grid" component={BlStatusGrid} />
                    <Route exact path="/log-book" component={LogBookGrid} />
                    <Route exact path="/master-brands-form" render={props => <MasterBrandsForm masterBrandData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateMasterBrand={(undefined => { })} />
                    } />
                    <Route exact path="/master-brands-grid" component={MasterBrandsGrid} />
                    <Route exact path="/cus-invoice-detail-view" component={CusInvoice} />
                    <Route exact path="/common-invoice-detail-view" component={CommonInvoice} />
                    <Route exact path="/plant-packing-list-view" component={PackingList} />

                    <Route exact path="/common-packing-list-view" component={CommonPackingList} />
                    <Route exact path="/shipping-instructions-view" component={ShippingInstructions} />
                    <Route exact path="/doc-upload-form" component={DocumentUploadForm} />

                    {/* <Route exact path="/tax-invoice-detail-view" component={TaxInvoice}/> */}
                    <Route exact path="/stock-grid" component={StockView} />
                    <Route exact path="/stock-out-transaction" component={StockOutTransaction} />
                    <Route exact path="/packing-stock-entry" component={PackingStockEntry} />
                    <Route exact path="/cycle-checker" component={CycleChecker} />
                    <Route exact path="/packing-product-conversion" component={PackingProductConversion} />
                    <Route exact path="/wh-dashboard" component={WarehouseDashboard} />
                    <Route exact path="/commercial-packing-list-view" component={CommercialPackingList} />
                    <Route exact path="/commercial-invoice-view" component={CommercialInvoice} />
                    <Route exact path="/invoice-grid" component={InvoiceGrid} />
                    <Route exact path="/invoice-detail-view" component={LogisticsInvoiceDetailView} />
                    <Route exact path="/freigst-invoice" component={FreigstInvoice} />
                    <Route exact path="/plant-invoice" component={PlantInvoice} />
                    <Route exact path="/plant-packing-list" component={PlantPackingList} />
                    <Route exact path="/document-register" component={DocumentRegister} />
                    <Route exact path="/po-print-view" component={PoPrint} />
                    <Route exact path="/isf-worksheet" component={IsfWorksheet} />

                    <Route exact path="/user-grid" component={UserPages} />
                    <Route exact path="/user-form" component={UserForm} />

                    <Route exact path="/procurement-dashboard" component={RmProcurementDashboard} />
                    <Route exact path="/rm-dashboard" component={RmDashboard} />
                    <Route exact path="/so-inspection" component={SoInspectionGrid} />

                    <Route exact path="/rm-grn-form" component={RawMaterialGrnForm} />
                    <Route exact path="/rm-grn-detailview" component={RawMaterialGrnDetailView} />
                    <Route exact path="/rm-grn-grid" component={RawMaterialGrnGrid} />
                    <Route exact path="/rm-grn-vehicle-inspection" component={RmVehicleInspection} />
                    <Route exact path="/transfer-print" component={TransferPrint} />
                    <Route exact path="/rm-indent-qty-limit-grid" component={RmIndentQtyLimitGrid} />
                    <Route exact path="/rm-indent-qty-limit" render={props => <RmIndentQtyLimit rmIndentQtyLimitData={undefined}
                        isUpdate={false}
                        closeForm={() => { }} updateRmIndentQtyLimit={() => { }} />

                    } />

                    <Route exact path="/indent-view" component={IndentGrid} />
                    <Route exact path="/indent-form" render={props => <IndentForm indentData={undefined}
                        isUpdate={false}
                        // form={''}
                        closeDrawer={() => { }}
                    // updateIndent={(undefined => { })} 
                    />

                    } />
                    <Route exact path="/indent-detail-view" component={IndentDetailView} />
                    <Route exact path="/vehicle-assignment" component={VehicleAssignmentGrid} />
                    <Route exact path="/assign-vehicle" component={VehicleAssignmentForm} />
                    <Route exact path="/vehicle-grid" component={VehicleMasterGrid} />
                    <Route exact path="/vehicle-form" render={props => <VehicleMasterForm
                        vehiclesData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateVehicle={(undefined => { })} />
                    } />
                    <Route exact path="/operations-view" component={OperationsGrid} />
                    <Route exact path="/operations-form" render={props => <OperationsForm
                        operationData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateOperation={(undefined => { })} />
                    } />
                    <Route exact path="/workstation-category-form" render={props => <WorkstationCategoryForm workstationCategoryData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateWorkstationCategory={(undefined => { })} />} />
                    <Route exact path="/workstation-category-grid" component={WorkstationCategoryGrid} />
                    <Route exact path="/workstations-form" render={props => <WorkstationsForm workstationData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateWorkstation={(undefined => { })} />} />
                    <Route exact path="/workstations-grid" component={WorkstationsGrid} />
                    <Route exact path="/qa-qc-operations" component={QaQcOperations} />
                    <Route exact path="/qa-qc-grid" component={QaQcGrid} />
                    <Route exact path="/varient-operations-form" component={VariantOperationsForm} />
                    <Route exact path="/inspection-form" component={InspectionForm} />
                    <Route exact path="/inspection-print" component={InspectionPrint} />
                    <Route exact path="/pd-qaqc" component={PdQaqcForm} />
                    <Route exact path="/pd-qaqc-print" component={PdQaqcPrint} />
                    <Route exact path="/metal-detection-grid" component={MetalDetection} />
                    <Route exact path="/metal-detection-form" component={MetalDetectionForm} />

                    <Route exact path="/be-heading" component={BeHeading} />
                    <Route exact path="/be-heading-dashboard" component={BeheadingDashboard} />
                    <Route exact path="/assign-to-val-addition" component={AssignGradeToValAddition} />
                    <Route exact path="/assign-soaking-for-freezing" component={AssignSoakingToFreezeGrid} />
                    <Route exact path="/rejections-grid" component={RejectionsGrid} />
                    <Route exact path="/bom-tracker-grid" component={BomTrackerGrid} />

                    <Route exact path="/soaking-material-detail-view" component={SoakingMaterialDetailView} />

                    {/* <Route exact path="/soaking-material-grid" component={SoakingMaterialGrid} /> */}
                    <Route exact path="/val-addition-inventory-grid" component={ValAdditionInventoryGrid} />
                    <Route exact path="/val-addition-soaking-grid" component={ValAdditionSoakingGrid} />
                    <Route exact path="/val-addition-grading-dashboard" component={ValAdditionGradingDashboard} />
                    <Route exact path="/grade-dashboard" component={GradingDashboard} />
                    <Route exact path="/assign-to-grading" component={AssignBeheadingToGrading} />
                    <Route exact path="/grade-reporting" component={GradeReporting} />
                    <Route exact path="/assign-so-to-grade" component={AssignSoGrading} />
                    <Route exact path="/grade-inventory" component={GradingInventoryGrid} />
                    <Route exact path="/yield-report" component={YieldReport} />
                    <Route exact path="/soaking-assignment-form" component={AssignSoakingMaterial} />
                    <Route exact path='/sub-plant-val-addition-report' component={SubPlantValAdditionsReport} />
                    {/* <Route exact path="/soaking-assignment-form" component={AssignSoakingMaterial} /> */}
                    <Route exact path="/production-inventory-grid" component={ProductionInventoryGrid} />
                    <Route exact path="/shippment-details-form" component={ShippmentDetailsForm} />
                     <Route exact path="/shippment-details-received-tab" component={ShippmentDetailsReceivedTabForm} />
                    <Route exact path="/be-heading-inventory" component={BeheadingInventoryGrid} />
                    <Route exact path="/be-heading-inprogress-inventory" component={BeheadingInprogressGrid} />
                    <Route exact path="/be-heading-sub-plant-history" component={BeheadingSubPlantHistory} />
                    <Route exact path="/cooking-grid" component={CookingGrid} />

                    <Route exact path="/soaking-assignment-grid" component={SoakingMaterialInventory} />
                    <Route exact path="/soaking-reporting" component={SoakingReporting} />
                    <Route exact path="/soaking-dashboard" component={SoakingDashboard} />
                    <Route exact path="/report-subplant-operations" component={ReportSubPlantOperations} />
                    <Route exact path="/receive-subplant-stock" component={ReceiveSubPlantsStockNew} />
                    <Route exact path="/assign-for-freezing-form" component={AssignForFreezingForm} />
                    <Route exact path="/grn-abstract-report-grid" component={GrnAbstractReportGrid} />
                    <Route exact path="/rm-procurement-report" component={RmProcurementReportGrid} />
                    <Route exact path="/lot-tracking-report" component={LotTrackingReport} />
                    <Route exact path="/operations-register" component={OperationsRegister} />
                    <Route exact path="/qa-qc-sample-test" component={QaQcSampleTest} />
                    <Route exact path="/qa-qc-sample-test-grid" component={QaQcSampleTestGrid} />
                    <Route exact path="/qa-qc-sample-detail-view" component={QaQcSampleDetailView} />
                    <Route exact path="/labelling-form" component={LabellingForm} />
                    <Route exact path="/labelling-grid" component={LabellingGrid} />
                    <Route exact path="/cooking-form" component={BlanchingCookingForm} />
                    <Route exact path="/assign-to-cooking" component={CookingForm} />
                    <Route exact path="/fg-inspection-form" component={FgInspectionForm} />
                    <Route exact path="/fg-inspection-print" component={FgInspectionPrint} />

                    {/* packing module access */}
                    {((
                        [
                            EmployeeRolesEnum.ADMIN,
                            EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                            EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                            EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER
                        ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) ? <>

                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/grn-rejection-reason-view" component={GrnRejectionReasonsGrid} />
                                <Route exact path="/grn-rejection-reason-form" render={props => <GrnRejectionReasonsForm rejectionreasonData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateReason={(undefined => { })} />} />
                            </>

                        }

                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.HO_PACKAGING_MANAGER
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/item-category-view" component={ItemCategoriesGrid} />
                                <Route exact path="/item-category-form" render={props => <ItemCategoriesForm itemcategoryData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateDetails={(undefined => { })}
                                />} />

                                <Route exact path="/item-sub-category-view" component={ItemSubCategoriesGrid} />
                                <Route exact path="/item-sub-category-form" render={props => <ItemSubCategoriesForm subCategoryData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateData={(undefined => { })}
                                />} />

                                <Route exact path="/TrimsView" component={TrimsGrid} />
                                <Route exact path="/trims-form" render={props => <TrimsForm
                                    trimsData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateTrims={(undefined => { })}
                                />
                                } />
                                <Route exact path="/types-grid" component={TypesGrid} />
                                <Route exact path="/types-form" render={props => <TypesForm
                                    typesData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateDetails={(undefined => { })}
                                />
                                } />
                                <Route exact path="/notify-party-grid" component={NotifyPartyGrid} />
                                <Route exact path="/notify-party-form" render={props => <NotifyPartyForm
                                    notifyPartyData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateNotifyParty={(undefined => { })}
                                />
                                } />
                                <Route exact path="/items-view" component={ItemsGrid} />
                                <Route exact path="/items-form" render={props => <ItemsForm itemData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateItem={(undefined => { })} />
                                } />

                                <Route exact path="/sizes-form" render={props => <SizesForm sizesData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateSize={(undefined => { })}
                                />
                                } />
                                <Route exact path="/sizes-view" component={SizesGrid} />

                                <Route exact path="/vendors-form" render={props => <VendorsForm vendorsData={undefined}
                                    isUpdate={false}
                                    closeForm={() => { }}
                                    updateDetails={(undefined => { })}
                                />} />

                                <Route exact path="/vendorsPriceListView" component={VendorPriceListGrid} />
                                <Route exact path="/vendorsPriceListForm" render={props => <VendorPriceListForm />} />
                                <Route exact path="/vendorsView" component={VendorsGrid} />
                            </>}

                        <Route exact path="/reasonsView" component={ReasonsGrid} />
                        <Route exact path="/reasons-form" render={props => <ReasonsForm reasonsData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateReasons={(undefined => { })} />}
                        />


                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>

                                <Route exact path="/grn-grid" component={GrnGrid} />
                                <Route exact path="/grn-detail-view" component={GrnDetailviewGrid} />
                                <Route exact path="/grn-form" render={props => <GrnForm
                                    isUpdate={false} />} />
                                <Route exact path='/grn-return-form' component={GrnReturnForm} />
                                <Route exact path='/grn-return-grid' component={GrnReturnGrid} />
                                <Route exact path='/grn-return-detail-view' component={GrnReturnDetailView} />
                                <Route exact path="/purchase-order-grid" component={PurchaseOrderGrid} />
                                <Route exact path="/po-detail-view/:id" render={props => <PoDetailViewPages />} />
                                <Route exact path="/purchase-order-form" render={props => <PurchaseOrderForm
                                    isUpdate={false}
                                    closeForm={() => { }} />
                                } />
                            </>}

                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.HO_PACKAGING_MANAGER
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/packing-dashboard" component={PackingDashboard} />
                                <Route exact path="/allsaleorders-view" component={SaleOrdersGrid} />
                                <Route exact path="/packing-bom-report" component={PackingBOM} />
                            </>}




                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/packing-stock-transfer" component={PackingStockTransfer} />

                                <Route exact path="/stock-transfer-grid" component={StockTransferGrid} />
                                <Route exact path="/stock-transfer-detail-view" component={StockTransferDetailView} />
                            </>}


                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/store-consumption-grid" component={StoreConsumptionGrid} />
                                <Route exact path="/store-consumption-detail-view" component={StoreConsumptionDetailView} />
                                <Route exact path="/store-consumption-form" render={props => <StoreConsumptionForm
                                    isUpdate={false}
                                    closeForm={() => { }} />
                                } />

                                <Route exact path="/store-return-form" render={props => <StoreReturnForm />} />
                                <Route exact path="/store-return" component={StoreReturnPages} />
                                <Route exact path="/store-return-grid" component={StoreReturnGrid} />
                                <Route exact path="/store-return-detail-view" component={StoreReturnDetailView} />
                            </>}


                    </> : ''}

                    <Route exact path="/sku-detail-view" component={SkuDetailView} />
                    <Route exact path="/sub-plant-operations-grid" component={SubPlantOperationsGrid} />
                    <Route exact path="/id-proofs" component={IdProofs} />
                    <Route exact path="/id-proofs-grid" component={IdProofsGrid} />
                    <Route exact path="/relations" component={Relations} />
                    <Route exact path="/relations-grid" component={RelationsGrid} />
                    <Route exact path="/expenses-category-form" component={ExpensesCategory} />
                    <Route exact path="/expenses-category-view" component={ExpensesCategoryGrid} />
                    <Route exact path="/expenses-sub-category-form" component={ExpensesSubCategory} />
                    <Route exact path="/expenses-sub-category-view" component={ExpensesSubCategoryGrid} />


                    <Route exact path="/loan-categories-grid" component={LoanCategoriesGrid} />
                    <Route exact path="/loan-categories-form" component={LoanCategories} />
                    <Route exact path='/over-time-categories-grid' component={OverTimeCategoryGrid} />
                    <Route exact path="/over-time-categories-form" component={OverTimeCategory} />
                    <Route exact path='/suggestion-view' component={SuggestionGrid} />
                    <Route exact path="/suggestion" component={Suggestion} />
                    <Route exact path='/complaints-view' component={ComplaintsGrid} />
                    <Route exact path="/complaints" component={Complaints} />
                    <Route exact path="/qualifications-view" component={QualificationsGrid} />
                    <Route exact path="/qualifications-form" component={QualificationsForm} />
                    <Route exact path="/skills-grid" component={SkillsGrid} />
                    <Route exact path="/skills" component={Skills} />
                    <Route exact path="/types-of-leaves-grid" component={TypesOfLeavesGrid} />
                    <Route exact path="/types-of-leaves" component={TypesOfLeaves} />
                    <Route exact path="/apply-for-leaves" component={ApplyForLeavesForm} />
                    <Route exact path="/apply-for-leaves-grid" component={ApplyForLeavesGrid} />
                    <Route exact path="/employee-leaves-grid" component={EmployeeLeavesGrid} />
                    <Route exact path="/leave-approval" component={LeaveApprovalGrid} />
                    <Route exact path="/job-notifications-view" component={JobNotificationsGrid} />
                    <Route exact path="/job-notifications-form" component={JobNotificationsForm} />
                    <Route exact path="/interview-view" component={InterviewGrid} />
                    <Route exact path="/interview-form" component={InterviewForm} />


                    <Route exact path="/inventory-stock-transfer-grid" component={ProductionInventoryTransfer} />
                    <Route exact path="/stock-out-grid" component={StockOut} />
                    <Route exact path="/reprocess-repacking" component={ReprocessingRepackingGrid} />
                    <Route exact path="/fg-stock-transfer-grid" component={FgStockTransferGrid} />
                    <Route exact path="/fg-stock-transfer" component={FgStockTransfer} />
                    <Route exact path="/reserve-racks" component={ReserveRackPositions} />
                    <Route exact path="/stock-summary-report" component={FgStockSummaryReport} />
                    <Route exact path="/fg-stock-report" component={FgStockReport} />
                    <Route exact path="/stock-report-warehouse" component={StockReportWarehouse} />
                    <Route exact path="/so-info-view" component={SoInfoView} />
                    <Route exact path="/stock-in-transactions" component={StockInTransactionsReport} />
                    <Route exact path="/stock-in-reverse" component={StockInReverse} />
                    <Route exact path="/shipment-status-report" component={ShipmentStatusReport} />
                    <Route exact path="/dummy-packing-report" component={DummyPackingReport} />


                    <Route exact path="/resource-operation-efficiency-form" render={props => <ResourceOperationEfficiencyForm resourceOpEfficiency={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateResourceOpEfficiency={(undefined) => { }}
                    />} />
                    <Route exact path="/plant-capacity-form" render={props => <PlantCapacityForm plantCapacity={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePlantCapacity={(undefined) => { }}
                    />} />

                    <Route exact path="/code-list-form" render={props => <CodeListForm codeListData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateCodeList={(undefined) => { }}
                    />} />
                    <Route exact path="/code-list-grid" component={CodeListGrid} />
                    <Route exact path="/code-list-print" component={CodeListPrint} />
                    <Route exact path="/code-list-main-form" component={CodeListMainForm} />
                    <Route exact path="/code-list-main-grid" component={CodeListMainGrid} />


                    <Route exact path="/resource-op-efficiency-view" component={ResourceOperationEfficiencyGrid} />

                    <Route exact path="/dispatch-list-grid" component={dispatchlistgrid} />
                    <Route exact path="/so-info-view" component={SoInfoViewPages} />
                    <Route exact path="/exit-action-view" component={ExitActionGrid} />
                    <Route exact path="/exit-action-form" render={props => <ExitActionForm exitActionData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateExitAction={(undefined) => { }}
                    />} />

                    <Route exact path="/education-form" component={Education} />
                    <Route exact path="/educations-view" component={EducationGrid} />
                    <Route exact path='/certification-form' component={Certification} />
                    <Route exact path='/certifications-view' component={CertificationGrid} />
                    <Route exact path="/designation-grid" component={DesignationGrid} />
                    <Route exact path="/designation" component={Designation} />
                    <Route exact path='/insurance-view' component={InsuranceGrid} />
                    <Route exact path='/insurance-form' component={InsuranceForm} />

                </Content>
                <Footer style={{ textAlign: 'center' }} className='noprint'>Design © {new Date().getUTCFullYear()} Created by Schemaxtech</Footer>
            </Layout>
        </Router>
    </Layout >
    )
});
export default BasicLayout
